const _WS_RE = /\s+/g;
const _ALT_WS = /\s+/g;




function mprGetSelectedLocKeys(oroot){
  const pills = Array.from(oroot.querySelectorAll(".mprPlacePill.is-active"));
  const keys = pills
    .map(p => (p.getAttribute("data-mpr-loc") || "").trim())
    .filter(Boolean)
    .map(k => normalizePlacementKey(k));

  if (keys.length) return keys;
  return [mprGetActiveLocKey(oroot) || "front"];
}



function mprSaveLogoRectInPrintBox(oroot){
  const shell    = mprGetShell(oroot) || oroot;
  const printBox = shell.querySelector("[data-mpr-printbox]");
  const box      = shell.querySelector("[data-mpr-logo-box]");
  const stageEl  = mprGetStageEl(shell) || printBox?.parentElement;

  if (!printBox || !box || !stageEl) return;

  let b = null;
  try { b = JSON.parse(printBox.dataset.mprBounds || "null"); } catch {}
  if (!b || !(b.width > 2 && b.height > 2)) return;

  const stageRect = stageEl.getBoundingClientRect();
  const boxRect   = box.getBoundingClientRect();

  const boxLeftStage = boxRect.left - stageRect.left;
  const boxTopStage  = boxRect.top  - stageRect.top;

  const r = {
    x: (boxLeftStage - b.left) / b.width,
    y: (boxTopStage  - b.top)  / b.height,
    w: boxRect.width  / b.width,
    h: boxRect.height / b.height,
  };

  oroot.dataset.mprLogoRectPB = JSON.stringify(r);
}

function mprRestoreLogoRectInPrintBox(oroot){
  const shell    = mprGetShell(oroot) || oroot;
  const printBox = shell.querySelector("[data-mpr-printbox]");
  const box      = shell.querySelector("[data-mpr-logo-box]");
  const stageEl  = mprGetStageEl(shell) || printBox?.parentElement;

  if (!printBox || !box || !stageEl) return;

  let b = null;
  try { b = JSON.parse(printBox.dataset.mprBounds || "null"); } catch {}
  if (!b || !(b.width > 2 && b.height > 2)) return;

  let r = null;
  try { r = JSON.parse(oroot.dataset.mprLogoRectPB || "null"); } catch {}
  if (!r) return;

  const stageRect  = stageEl.getBoundingClientRect();
  const parent     = box.offsetParent || stageEl || shell;
  const parentRect = parent.getBoundingClientRect();

  const leftStage = b.left + (r.x * b.width);
  const topStage  = b.top  + (r.y * b.height);
  const w         = r.w * b.width;
  const h         = r.h * b.height;

  const left = (stageRect.left + leftStage) - parentRect.left;
  const top  = (stageRect.top  + topStage)  - parentRect.top;

  box.style.left   = `${left}px`;
  box.style.top    = `${top}px`;
  box.style.width  = `${w}px`;
  box.style.height = `${h}px`;
}



function mprGetUploadedLocKeys(oroot){
  const map = mprGetLocStateMap(oroot);

  const out = [];
  for (const [k, st] of map.entries()) {
    const key = normalizePlacementKey(k || "");
    if (!key) continue;
    if (st?.dataUrl) out.push(key);
  }
  out.sort((a, b) => {
    if (a === "front") return -1;
    if (b === "front") return  1;
    if (a === "back")  return -1;
    if (b === "back")  return  1;
    return a.localeCompare(b);
  });

  if (out.length) return out;

  const active = mprGetActiveLocKey(oroot) || "front";
  return [normalizePlacementKey(active)];
}



//


function mprFindLocGroupInput(overlay, locKey) {
  const groups = overlay.querySelector("[data-mpr-upload-groups]");
  if (!groups) return null;

  const key = String(locKey || "").trim();

  return (
    groups.querySelector(`[data-mpr-upload-group="${CSS.escape(key)}"] input[type="file"]`) ||
    groups.querySelector(`input[type="file"][data-mpr-loc-file="${CSS.escape(key)}"]`) ||
    groups.querySelector("input[type='file']")
  );
}


function mprSetInputFiles(input, file) {
  const dt = new DataTransfer();
  dt.items.add(file);
  input.files = dt.files;
}



function mprBindUnifiedUploads(root) {
  const overlay = root.closest("[data-mpr-overlay]") || document;
  if (overlay.dataset.mprUnifiedUploadsBound) return;
  overlay.dataset.mprUnifiedUploadsBound = "1";

  const panelInput = overlay.querySelector(".mprUploadPanel__fileInput");
  const panelFileNameEl = overlay.querySelector("[data-mpr-upload-filename]");
  const stageUploadBtn = overlay.querySelector("[data-mpr-stage-upload]");

  // ✅ NEW: always use a temp picker so browser never blocks it
  function openPickerForActiveLoc() {
    const locKey = mprGetActiveLocKey(overlay);
    const locInput = mprFindLocGroupInput(overlay, locKey);

    // Create a temporary input that is NOT display:none
    const picker = document.createElement("input");
    picker.type = "file";
    picker.accept = "image/*,.svg";
    picker.style.position = "fixed";
    picker.style.left = "-9999px";
    picker.style.top = "0";
    picker.style.opacity = "0";
    picker.style.width = "1px";
    picker.style.height = "1px";

    document.body.appendChild(picker);

    picker.addEventListener(
      "change",
      () => {
        const file = picker.files?.[0];
        if (!file) {
          picker.remove();
          return;
        }

        if (panelFileNameEl) panelFileNameEl.textContent = file.name;

        // push file into loc input (so your existing change listeners run)
        if (locInput) {
          try { mprSetInputFiles(locInput, file); } catch {}
          locInput.dispatchEvent(new Event("change", { bubbles: true }));
        }

        // keep panel input synced if you want it for display
        if (panelInput && panelInput !== locInput) {
          try { mprSetInputFiles(panelInput, file); } catch {}
        }

        picker.remove();
      },
      { once: true }
    );

    picker.click();
  }

  if (stageUploadBtn) {
    stageUploadBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      openPickerForActiveLoc();
    });
  }

  // Keep your other listeners as-is (panel input + groups)
  if (panelInput) {
    panelInput.addEventListener("change", () => {
      const file = panelInput.files?.[0];
      if (!file) return;

      const locKey = mprGetActiveLocKey(overlay);
      const locInput = mprFindLocGroupInput(overlay, locKey);

      if (panelFileNameEl) panelFileNameEl.textContent = file.name;

      if (locInput && locInput !== panelInput) {
        mprSetInputFiles(locInput, file);
        locInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  }

  const groups = overlay.querySelector("[data-mpr-upload-groups]");
  if (groups) {
    groups.addEventListener("change", (e) => {
      const inp = e.target;
      if (!(inp instanceof HTMLInputElement) || inp.type !== "file") return;

      const file = inp.files?.[0];
      if (!file) return;

      if (panelFileNameEl) panelFileNameEl.textContent = file.name;
      if (panelInput && panelInput !== inp) {
        try { mprSetInputFiles(panelInput, file); } catch {}
      }
    });
  }
}










 function mprNormalizeSiteInput(s) {
  const raw = String(s || "").trim();
  if (!raw) return "";
  return raw.replace(/^https?:\/\//i, "").trim();
}

async function mprFetchLogoFromSite(site) {
  const q = mprNormalizeSiteInput(site);
  if (!q) return { ok: false, error: "empty" };

  const endpoint = "https://get-brand-logo-url.inkdstores.workers.dev";
  if (!endpoint) return { ok: false, error: "missing-worker-endpoint" };

  const url = endpoint.replace(/\/+$/, "") + "/logo?q=" + encodeURIComponent(q);

  let res;
  try {
    res = await fetch(url, {
      method: "GET",
      headers: { "accept": "application/json" },
      credentials: "omit",
      cache: "no-store",
    });
  } catch (e) {
    return { ok: false, error: "network" };
  }

  const j = await res.json().catch(() => ({}));
  if (!res.ok || !j || !j.ok || !j.logoUrl) {
    return { ok: false, error: j?.error || `logo-${res.status}` };
  }

  return { ok: true, logoUrl: String(j.logoUrl) };
}


async function mprFetchAsObjectUrl(src) {
  const url = String(src || "").trim();
  if (!url) return { ok: false, error: "empty-src" };

  try {
    const res = await fetch(url, { mode: "cors", cache: "no-store", credentials: "omit" });
    if (!res.ok) return { ok: false, error: `fetch-${res.status}` };

    const blob = await res.blob();
    if (!blob) return { ok: false, error: "no-blob" };

    const objUrl = URL.createObjectURL(blob);
    return { ok: true, objUrl };
  } catch (e) {
    return { ok: false, error: "fetch-failed" };
  }
}







async function mprSetLogoFromUrlToActiveLoc(oroot, logoUrl) {
  const overlay = mprGetOverlay(oroot) || document;
  const shell   = mprGetShell(oroot) || overlay;

  const locKey = normalizePlacementKey(mprGetActiveLocKey(oroot) || "front");

  const logoImg =
    shell.querySelector("[data-mpr-logo-img]") ||
    shell.querySelector(".mprLogoLayer__img") ||
    shell.querySelector("img[data-mpr-logo]");

  const layer =
    shell.querySelector("[data-mpr-logo-layer]") ||
    shell.querySelector(".mprLogoLayer");

  const stageImg =
    overlay.querySelector("[data-mpr-overlay-img]") ||
    overlay.querySelector("[data-mpr-stageimg]") ||
    overlay.querySelector(".mprOverlayStage__img") ||
    overlay.querySelector("img[data-mpr-mainimg]");

  if (!logoImg || !layer) return false;

  try { mprPositionPrintBox(oroot, locKey); } catch {}

  const hadLogo = mprHasLogo(shell);
  if (hadLogo) {
    try { mprSaveLogoRectInPrintBox(oroot); } catch {}
    try { mprSaveLogoRectNorm?.(shell, locKey); } catch {}
  } else {
    try { delete shell.dataset.mprLogoRect; } catch {}
    try { delete oroot.dataset.mprLogoRectPB; } catch {}
  }

  const prev = mprGetSavedLocState(oroot, locKey);
  if (prev?.dataUrl && String(prev.dataUrl).startsWith("blob:")) {
    try { URL.revokeObjectURL(prev.dataUrl); } catch {}
  }

  const fetched = await mprFetchAsObjectUrl(logoUrl);
  const displaySrc = fetched.ok ? fetched.objUrl : String(logoUrl || "");

  logoImg.crossOrigin = "anonymous";
  logoImg.src = displaySrc;
  layer.hidden = false;

  const hiddenLogoUrl = shell.querySelector('input[type="hidden"][data-mpr-logo-url]');
  if (hiddenLogoUrl) hiddenLogoUrl.value = String(logoUrl || "");

  mprSaveLocState(oroot, locKey, {
    dataUrl: displaySrc,
    logoUrl: String(logoUrl || ""),
    filename: String(logoUrl || "").split("/").pop() || "logo.png",
    colorCount: 1,
    palette: [],
  });

  mprSetActiveLocKey(oroot, locKey);
  mprSwapStageLogoToLoc(oroot, locKey);

  try { if (stageImg) await mprWaitImg(stageImg, 20000); } catch {}
  try { await mprWaitImg(logoImg, 15000); } catch (e) {
    console.warn("[mpr-site-logo] logo failed to load", e);
    return false;
  }

  requestAnimationFrame(() => {
    try { mprSnapLogoIntoPrintBox(oroot, locKey); } catch {}
  });

  try { mprSetHasLogo?.(shell, true); } catch {}
  try { mprSyncHasLogoClass?.(shell); } catch {}

  return true;
}






function mprBindWebsiteLogoInput(overlayOrRoot) {
  const overlay =
    (overlayOrRoot && overlayOrRoot.matches && overlayOrRoot.matches("[data-mpr-overlay]")
      ? overlayOrRoot
      : mprGetOverlay(overlayOrRoot)) || document.querySelector("[data-mpr-overlay]") || document;

  const input = overlay.querySelector("[data-mpr-site-input]");
  if (!input) return;

  if (input.dataset.mprBound) return;
  input.dataset.mprBound = "1";

  let _mprSiteTimer = null;
  let _mprSiteLast = "";

  const run = async () => {
    const site = input.value;
    if (!String(site || "").trim()) return;

    try {
      await mprWithBusy(overlay, async () => {
        const found = await mprFetchLogoFromSite(site);
        if (!found.ok) throw new Error(found.error || "logo-fetch-failed");

        const oroot =
          overlay.querySelector("[data-mpr-overlay-root]") ||
          overlay.querySelector(".mprOverlayShell") ||
          overlay;

        const ok = await mprSetLogoFromUrlToActiveLoc(oroot, found.logoUrl);
        if (!ok) throw new Error("logo-apply-failed");
      }, "Finding logo…");
    } catch (e) {
      console.warn("[mpr-site-logo] failed:", e?.message || e);
    }
  };

  input.addEventListener("keydown", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      run();
    }
  });

  input.addEventListener("change", run);

  input.addEventListener("blur", run);

}





//




function mprSyncViewTabsFromProductImages(oroot, productData, activeColorToken) {
  const overlay = mprGetOverlay(oroot) || document;
  const viewsWrap = overlay.querySelector("[data-mpr-views]");
  if (!viewsWrap || !productData) return;

  const imgs = Array.isArray(productData.images) ? productData.images : [];
  function pickImageForLoc(locKey) {
    const wantLoc = normToken(locKey);

    if (activeColorToken) {
      const hit = imgs.find(im => {
        const meta = parseMprAlt(im?.alt);
        return meta && meta.color === activeColorToken && meta.loc === wantLoc;
      });
      if (hit) return hit;
    }
    const hitLocOnly = imgs.find(im => {
      const meta = parseMprAlt(im?.alt);
      return meta && meta.loc === wantLoc;
    });
    if (hitLocOnly) return hitLocOnly;
    return imgs[0] || null;
  }
  const btns = Array.from(viewsWrap.querySelectorAll("[data-mpr-view]"));
  let anySecond = false;

  btns.forEach((btn, idx) => {
    const locKey = btn.dataset.mprView || btn.getAttribute("data-mpr-view") || "";
    const picked = pickImageForLoc(locKey);

    const thumbImg = btn.querySelector("img[data-mpr-viewthumb]");
    if (picked?.thumb && thumbImg) thumbImg.src = picked.thumb;

    if (picked?.full) btn.dataset.mprViewFull = picked.full;

    if (idx === 1) {
      const meta = picked ? parseMprAlt(picked.alt) : null;
      anySecond = !!(meta && meta.loc === normToken(locKey));
    }
  });

  if (btns.length >= 2) {
    btns[1].hidden = !anySecond;
  }
}





function mprFindViewBtnByLocKey(oroot, locKey){
  const viewsWrap = oroot.querySelector("[data-mpr-views]");
  if (!viewsWrap) return null;
  const want = normalizePlacementKey(locKey);
  return Array.from(viewsWrap.querySelectorAll("[data-mpr-view]"))
    .find(b => normalizePlacementKey(b.dataset.mprLocKey || "") === want) || null;
}

function mprRevokeMany(urls){
  (urls || []).forEach(u => mprRevokeObjectUrlSafe(u));
}

async function mprBuildClientPreviewsForLocs(oroot, locKeys){
  const overlay = mprGetOverlay(oroot);
  const shell   = mprGetShell(oroot) || oroot;

  if (overlay.__mprQtyPreviewUrls) {
    mprRevokeMany(overlay.__mprQtyPreviewUrls);
  }
  overlay.__mprQtyPreviewUrls = [];

  const prevKey = mprGetActiveLocKey(oroot) || (overlay?.dataset?.mprActiveLocKey || "front");

  const out = [];

  for (let i = 0; i < locKeys.length; i++){
    const locKey = normalizePlacementKey(locKeys[i] || "");
    if (!locKey) continue;

    const btn = mprFindViewBtnByLocKey(oroot, locKey);
    
    const overlayEl = mprGetOverlay(oroot) || document;

    const viewsWrap = overlayEl.querySelector("[data-mpr-views]");
    const stageImg =
      overlayEl.querySelector("[data-mpr-overlay-img]") ||
      overlayEl.querySelector("[data-mpr-stageimg]") ||
      overlayEl.querySelector(".mprOverlayStage__img") ||
      overlayEl.querySelector("img[data-mpr-mainimg]");

    if (viewsWrap) {
      const prevActive = viewsWrap.querySelector("[data-mpr-view].is-active");
      if (prevActive) prevActive.classList.remove("is-active");
    }
    if (btn) btn.classList.add("is-active");

    if (stageImg) {
      const full = (btn && btn.dataset.mprViewFull) ? btn.dataset.mprViewFull : "";
      if (full) stageImg.src = full;
    }

    mprSetActiveLocKey(oroot, locKey);
    mprPositionPrintBox(oroot, locKey);
    mprSwapStageLogoToLoc(oroot, locKey);
    requestAnimationFrame(() => mprRestoreLogoRectNorm(oroot, locKey));





    const st = mprGetSavedLocState(oroot, locKey);
    if (!st?.dataUrl) continue;

    mprSwapStageLogoToLoc(oroot, locKey);
    const blob = await mprBuildCompositeStageImage(oroot);
    const url  = URL.createObjectURL(blob);

    overlay.__mprQtyPreviewUrls.push(url);
    out.push({ locKey, locName: (btn?.dataset?.mprLocName || locKey), url });
  }

  const backBtn = mprFindViewBtnByLocKey(oroot, prevKey);
  if (backBtn) backBtn.click();
  else {
    mprSetActiveLocKey(oroot, prevKey);
    mprSwapStageLogoToLoc(oroot, prevKey);
    mprPositionPrintBox(oroot, prevKey);
  }

  return out;
}


function mprRenderQtyMockups(oroot, items){
  const host =
    oroot.querySelector("[data-mpr-qty-mockups]") ||
    $(oroot, "[data-mpr-sizegrid]")?.parentElement;

  if (!host) return;
  const locLine =
  oroot.querySelector("[data-mpr-qty-locline]") ||
  (mprGetOverlay(oroot) || document).querySelector("[data-mpr-qty-locline]");

  if (locLine) {
    const names = (items || []).map(it => (it.locName || it.locKey || "").trim()).filter(Boolean);
    locLine.textContent = names.length ? ("Location: " + names.join(", ")) : "";
  }



  if (!items || !items.length) {
    host.innerHTML = "";
    host.hidden = true;
    return;
  }

  host.hidden = false;
  host.innerHTML = items.map(it => `
    <div class="mprQtyMockups__item">
      <div class="mprQtyMockups__cap">${escapeHtml(it.locName || it.locKey)}</div>
      <img class="mprQtyMockups__img" src="${escapeHtml(it.url)}" alt="">
    </div>
  `).join("");
}








function mprRevokeObjectUrlSafe(url) {
  try { if (url && url.startsWith("blob:")) URL.revokeObjectURL(url); } catch {}
}

async function mprShowClientPreview(oroot) {
  const overlay = mprGetOverlay(oroot);
  const shell   = mprGetShell(oroot) || oroot;

  const compositeBlob = await mprBuildCompositeStageImage(oroot);

  const url = URL.createObjectURL(compositeBlob);

  if (overlay?.dataset?.mprClientPreviewUrl) {
    mprRevokeObjectUrlSafe(overlay.dataset.mprClientPreviewUrl);
  }

  if (overlay) overlay.dataset.mprClientPreviewUrl = url;

  mprSetStageImage(overlay, url);
  window.mprSyncViewThumbs?.(url);

  const layer = shell.querySelector("[data-mpr-logo-layer]") || shell.querySelector(".mprLogoLayer");
  if (layer) layer.hidden = true;

  const printBox = shell.querySelector("[data-mpr-printbox]");
  if (printBox) printBox.hidden = true;

  return url;
}



function mprKickoffWorkerMockup(oroot) {
  const overlay = mprGetOverlay(oroot);
  const shell   = mprGetShell(oroot) || oroot;

  if (!overlay) return null;

  if (overlay.__mprWorkerPromise) return overlay.__mprWorkerPromise;

  mprSaveLogoRectNorm(shell);
  const rectJson = shell.dataset.mprLogoRect || "";
  const bbox = rectJson ? JSON.parse(rectJson) : null;

  const productData = mprGetActiveProductDataFromOverlay(overlay) || {};
  const productName = productData?.title || "";
  const decoration  = mprGetSelectedDecorationMethodFromOverlayRoot(shell);

  overlay.dataset.mprWorkerStatus = "running";

  overlay.__mprWorkerPromise = (async () => {
    const result = await mprSendCompositeToWorker(oroot, {
      baseUrl: MPR_WORKER_PROCESS_ENDPOINT,
      productName,
      decoration,
      bbox,
    });

    overlay.dataset.mprWorkerStatus = "done";
    overlay.dataset.mprMockupUrlPending = String(result?.url || "");
    const mockHidden = shell.querySelector('input[type="hidden"][data-mpr-mockup-url]');
    if (mockHidden) mockHidden.value = String(result?.url || "");

    return result;
  })().catch((err) => {
    overlay.dataset.mprWorkerStatus = "error";
    overlay.dataset.mprWorkerErr = String(err?.message || err || "worker-error");
    throw err;
  });

  return overlay.__mprWorkerPromise;
}


async function mprApplyWorkerMockupIfReady(oroot) {
  const overlay = mprGetOverlay(oroot);
  const shell   = mprGetShell(oroot) || oroot;
  if (!overlay) return null;

  const pending = (overlay.dataset.mprMockupUrlPending || "").trim();

  if (pending) {
    await mprSetStageMockup(oroot, pending);
    return pending;
  }

  const p = overlay.__mprWorkerPromise;
  if (!p) return null;

  const result = await mprWithBusy(oroot, () => p, "Generating mockup…");
  const url = String(result?.url || "").trim();
  if (url) {
    overlay.dataset.mprMockupUrlPending = url;
    await mprSetStageMockup(oroot, url);
    return url;
  }

  return null;
}






function mprEnsureWorkerPromise(overlayRoot){
  const overlay = mprGetOverlay(overlayRoot);
  if (!overlay) return null;

  if (!overlay.__mprWorkerPromise) {
    overlay.__mprWorkerPromise = Promise.resolve()
      .then(() => mprKickoffWorkerMockup(overlayRoot)); 
  }
  return overlay.__mprWorkerPromise;
}

function mprApplyWorkerMockupIfPresent(overlayRoot, result){
  const overlay = mprGetOverlay(overlayRoot);
  if (!overlay) return;

  const url = (result && result.mockupUrl) || overlay.dataset.mprMockupUrl || "";
  if (!url) return;

  overlay.dataset.mprMockupUrl = url;

  const img = overlay.querySelector("[data-mpr-overlay-img]");
  if (img) img.src = url;

  const hidden = overlay.querySelector('input[type="hidden"][data-mpr-mockup-url]');
  if (hidden) hidden.value = url;
}





//




function normKey(s) {
  return String(s || "").trim().toLowerCase().replace(_WS_RE, " ");
}

function mprSetBusy(anyRoot, on, label) {
  const overlay = mprGetOverlay(anyRoot);
  if (!overlay) return;

  const busy = overlay.querySelector("[data-mpr-busy]");
  if (!busy) return;

  const turnOn = !!on;

  if (turnOn) busy.removeAttribute("hidden");
  else busy.setAttribute("hidden", "true");

  busy.setAttribute("aria-hidden", turnOn ? "false" : "true");

  if (label) {
    const sp = busy.querySelector(".mprBusy__spinner");
    if (sp) sp.setAttribute("aria-label", String(label));
  }
}

async function mprWithBusy(anyRoot, fn, label) {
  mprSetBusy(anyRoot, true, label || "Loading");
  try {
    return await fn();
  } finally {
    mprSetBusy(anyRoot, false);
  }
}



function normToken(s){
  return String(s || "")
    .trim()
    .toLowerCase()
    .replace(_ALT_WS, "");
}

function parseMprAlt(alt){
  const parts = String(alt || "").split(":").map(p => p.trim());
  if (parts.length < 3) return null;

  const tag = normToken(parts[0]);    
  const color = normToken(parts[1]); 
  const loc = normToken(parts[2]);   

  if (tag !== "placement") return null;
  return { color, loc };
}


function mprGetActiveVariantImageUrl(root, productData) {
  const activeVariant = mprGetActiveVariant?.(root, productData);
  if (activeVariant) return getVariantImageUrl(activeVariant);

  const pdpMain = document.querySelector('img[data-mpr-mainimg], .product__media img, img[aria-current="true"]');
  const src = pdpMain?.currentSrc || pdpMain?.src || null;
  if (!src) return null;
  return src.includes("width=") ? src : src + (src.includes("?") ? "&" : "?") + "width=1600";
}


function mprSetStageImage(overlay, src) {
  if (!overlay || !src) return;
  const stageImg =
    overlay.querySelector("[data-mpr-overlay-img]") ||
    overlay.querySelector("[data-mpr-stageimg]") ||
    overlay.querySelector(".mprOverlayStage__img") ||
    overlay.querySelector("img[data-mpr-mainimg]");
  if (stageImg) stageImg.src = src;
}

function mprSetLocationThumbsToSingleImage(overlay, src) {
  if (!overlay || !src) return;
  overlay.querySelectorAll("[data-mpr-view]").forEach((btn) => {
    btn.dataset.mprViewFull = src;
    const im = btn.querySelector("img");
    if (im) im.src = src;
    if (!btn.dataset.mprLocName) btn.dataset.mprLocName = btn.textContent?.trim() || "";

  });
}




function mprBuildUploadGroups(oroot){
  const wrap = oroot.querySelector("[data-mpr-upload-groups]");
  if (!wrap) return;

  const viewsWrap = oroot.querySelector("[data-mpr-views]");
  const btns = Array.from(viewsWrap?.querySelectorAll("[data-mpr-view]") || []);
  if (!btns.length) { wrap.innerHTML = ""; return; }

  wrap.innerHTML = "";

  btns.forEach((btn) => {
    const locKey = (btn.dataset.mprLocKey || "").trim() || "front";
    const locName = (btn.dataset.mprLocName || btn.textContent || locKey).trim();

    const group = document.createElement("div");
    group.className = "mprUploadGroup";
    group.setAttribute("data-mpr-upload-group", locKey);

    group.innerHTML = `
      <div class="mprUploadGroup__head">
        <div class="mprUploadGroup__title">${escapeHtml(locName)}</div>
        <div class="mprUploadGroup__meta" data-mpr-colormeta></div>
      </div>
      <div class="mprUploadGroup__body">
        <input type="file" accept="image/*,.svg" data-mpr-loc-file="${escapeHtml(locKey)}">
        <div class="mprUploadGroup__hint">Upload a logo for this location.</div>
      </div>
    `;

    const input = group.querySelector(`input[data-mpr-loc-file="${CSS.escape(locKey)}"]`);
    input.addEventListener("change", async () => {
      const f = input.files && input.files[0];
      if (!f) return;

      btn.click();

      const name = (f.name || "").toLowerCase();
      const isSvg = name.endsWith(".svg") || f.type === "image/svg+xml";
      let count = 1, palette = [];
      if (!isSvg) {
        const res = await mprCountDominantColorsFromFile(f);
        if (res?.ok) { count = res.colorCount || 1; palette = res.palette || []; }
      }

      mprSaveLocState(oroot, locKey, { colorCount: count, palette, filename: f.name || "" });
      mprSetColorMeta(group, `Detected colors: ${count}`, palette);

      const reader = new FileReader();

      reader.onload = async () => {
        const dataUrl = String(reader.result || "");

        mprApplyLogoFromDataUrl(oroot, dataUrl);

        const shell = mprGetShell(oroot) || oroot;
        const logoImg =
          shell.querySelector("[data-mpr-logo-img]") ||
          shell.querySelector(".mprLogoLayer__img") ||
          shell.querySelector("img[data-mpr-logo]");

        try { await mprWaitImg(logoImg, 15000); } catch {}

        requestAnimationFrame(() => {
          try { mprSnapLogoIntoPrintBox(oroot, locKey); } catch {}
        });
      };



      reader.readAsDataURL(f);
    });

    const st = mprGetSavedLocState(oroot, locKey);
    if (st?.colorCount) mprSetColorMeta(group, `Detected colors: ${st.colorCount}`, st.palette || []);

    wrap.appendChild(group);
  });
}





function mprWaitImg(img, timeoutMs = 15000) {
  return new Promise((resolve, reject) => {
    if (!img) return resolve();
    if (img.complete && img.naturalWidth > 0) return resolve();

    const onLoad = () => cleanup(resolve);
    const onErr  = () => cleanup(() => reject(new Error("image-load-failed")));
    const to = setTimeout(() => cleanup(() => reject(new Error("image-load-timeout"))), timeoutMs);

    function cleanup(done) {
      clearTimeout(to);
      img.removeEventListener("load", onLoad);
      img.removeEventListener("error", onErr);
      done();
    }

    img.addEventListener("load", onLoad, { once: true });
    img.addEventListener("error", onErr, { once: true });
  });
}


function mprCleanLocationLabel(raw) {
  let s0 = String(raw || "").trim();
  if (!s0) return { label: "", key: "" };

  s0 = s0
    .replace(/\s*\(\s*id\s*:\s*\d+\s*\)\s*$/i, "")
    .replace(/\s*\(\s*\d+\s*\)\s*$/, "")
    .replace(/\s*-\s*\d+\s*$/, "")
    .trim();

  const label = s0
    .replace(/\s+/g, " ")
    .replace(/\s*\/\s*/g, " / ")
    .trim();

  let key = normalizePlacementKey(label);

  const ALIASES = {
    "center chest": "front",
    "full front": "front",
    "front chest": "front",
    "left chest": "front",
    "right chest": "front",

    "full back": "back",
    "upper back": "back",

    "left sleeve": "sleeve",
    "right sleeve": "sleeve",
    "sleeves": "sleeve",

    "1 side": "1-side",
    "2 side": "2-side",
    "full wrap": "full wrap",
  };

  if (ALIASES[key]) key = ALIASES[key];

  return { label, key };
}



async function mprBuildCompositeStageImage(anyRoot) {
  const overlay = mprGetOverlay(anyRoot) || document;
  const shell   = mprGetShell(anyRoot) || overlay;

  const stageImg =
    overlay.querySelector("[data-mpr-overlay-img]") ||
    overlay.querySelector("[data-mpr-stageimg]") ||
    overlay.querySelector(".mprOverlayStage__img") ||
    overlay.querySelector("img[data-mpr-mainimg]");

  const logoImg =
    shell.querySelector("[data-mpr-logo-img]") ||
    shell.querySelector(".mprLogoLayer__img") ||
    shell.querySelector("img[data-mpr-logo]");

  const logoBox =
    shell.querySelector("[data-mpr-logo-box]") ||
    shell.querySelector(".mprLogoLayer__box");

  if (!stageImg || !logoImg || !logoBox) {
    console.warn("[mprBuildCompositeStageImage] missing els:", {
      hasStageImg: !!stageImg,
      hasLogoImg:  !!logoImg,
      hasLogoBox:  !!logoBox,
      anyRoot: anyRoot,
      overlay: overlay,
      shell: shell,
    });
    throw new Error("Missing stageImg/logoImg/logoBox");
  }

  await Promise.all([
    stageImg.complete ? Promise.resolve() : new Promise((res) => stageImg.addEventListener("load", res, { once: true })),
    logoImg.complete  ? Promise.resolve() : new Promise((res) => logoImg.addEventListener("load",  res, { once: true })),
  ]);

  const W = stageImg.naturalWidth  || stageImg.width  || 1600;
  const H = stageImg.naturalHeight || stageImg.height || 1600;

  const canvas = document.createElement("canvas");
  canvas.width = W;
  canvas.height = H;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("no-canvas-ctx");

  ctx.drawImage(stageImg, 0, 0, W, H);

  const stageRect = stageImg.getBoundingClientRect();
  const boxRect   = logoBox.getBoundingClientRect();

  const scaleX = W / (stageRect.width  || 1);
  const scaleY = H / (stageRect.height || 1);

  const x = (boxRect.left - stageRect.left) * scaleX;
  const y = (boxRect.top  - stageRect.top)  * scaleY;
  const w = boxRect.width  * scaleX;
  const h = boxRect.height * scaleY;

  ctx.drawImage(logoImg, x, y, w, h);

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png", 0.92));
  if (!blob) throw new Error("Failed to create composite blob");
  return blob;
}




async function mprSendCompositeToWorker(stageRoot, { baseUrl, productName, decoration, bbox }) {
  const compositeBlob = await mprBuildCompositeStageImage(stageRoot);

  const fd = new FormData();
  fd.append("file", compositeBlob, "composite.png");
  fd.append("product_name", productName || "");
  fd.append("decoration_name", decoration || "");
  if (bbox) fd.append("bbox", JSON.stringify(bbox));

  const res = await fetch(String(baseUrl || "").replace(/\/+$/, "") + "/mockup/enhance", {
    method: "POST",
    body: fd,
  });

  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`Worker failed: ${res.status} ${txt}`);
  }
  return res.json();
}





const MPR_WORKER_PROCESS_ENDPOINT =
  "https://quiet-water-d34c.inkdstores.workers.dev"; 

function mprGetActiveProductDataFromOverlay(overlay){
  const id = overlay?.dataset?.mprActiveId;
  if (!id) return null;
  const dataTag = document.getElementById(`mpr-product-${id}`);
  if (!dataTag) return null;
  try { return JSON.parse(dataTag.textContent || "{}"); } catch { return null; }
}

function mprGetSelectedDecorationMethodFromOverlayRoot(oroot){
  return (mprGetSelectedDecorationMethod(oroot) || "").trim();
}

function mprSwapLogoSrcPreserveRect(oroot, newSrc) {
  const shell = mprGetShell(oroot);
  const img = shell.querySelector("[data-mpr-logo-img]");
  const layer = shell.querySelector("[data-mpr-logo-layer]") || shell.querySelector(".mprLogoLayer");
  if (!img || !layer) return false;

  mprSaveLogoRectNorm(shell);

  const rectBefore = shell.dataset.mprLogoRect || "";
  img.onload = () => {
    if (rectBefore) shell.dataset.mprLogoRect = rectBefore;
    requestAnimationFrame(() => mprRestoreLogoRectNorm(shell));
  };

  img.src = newSrc;
  layer.hidden = false;

  mprSetHasLogo(shell, true);
  mprSyncHasLogoClass(shell);

  return true;
}



async function mprSendLogoToWorkerOnNext(oroot) {
  const overlay = mprGetOverlay(oroot);
  const shell = mprGetShell(oroot);

  if (!mprHasLogo(shell)) {
    throw new Error("no-logo");
  }

  mprSaveLogoRectNorm(shell);
  const rectJson = shell.dataset.mprLogoRect || "";

  const productData = mprGetActiveProductDataFromOverlay(overlay) || {};
  const productName = productData?.title || "";

  const decoration = mprGetSelectedDecorationMethodFromOverlayRoot(shell);

  const fileInput = shell.querySelector('input[type="file"][data-mpr-stage-file]');
  const file = fileInput?.files?.[0] || null;

  const existingUrl = (shell.querySelector('input[type="hidden"][data-mpr-logo-url]')?.value || "").trim();
  if (!existingUrl) throw new Error("no-logo-url");


  const bbox = rectJson ? JSON.parse(rectJson) : null;


  const result = await mprWithBusy(oroot, () => (
    mprSendCompositeToWorker(oroot, {
      baseUrl: MPR_WORKER_PROCESS_ENDPOINT,
      productName,
      decoration,
      bbox,
    })
  ), "Generating mockup…");



  if (overlay) overlay.dataset.mprMockupUrl = String(result.url || "");

  const mockHidden = shell.querySelector('input[type="hidden"][data-mpr-mockup-url]');
  if (mockHidden) mockHidden.value = String(result.url || "");


  mprSetStageMockup(oroot, result.url);

  return result;

}






function mprSaveLogoRectPx(oroot){
  const box = oroot.querySelector("[data-mpr-logo-box]");
  if (!box) return;

  const r = {
    x: box.offsetLeft,
    y: box.offsetTop,
    w: box.offsetWidth,
    h: box.offsetHeight,
  };

  oroot.dataset.mprLogoRectPx = JSON.stringify(r);
}

function mprRestoreLogoRectPx(oroot){
  const box = oroot.querySelector("[data-mpr-logo-box]");
  if (!box) return;

  let r;
  try { r = JSON.parse(oroot.dataset.mprLogoRectPx || "null"); } catch { r = null; }
  if (!r) return;

  box.style.left = `${r.x}px`;
  box.style.top = `${r.y}px`;
  box.style.width = `${r.w}px`;
  box.style.height = `${r.h}px`;
}


function mprGetStageEl(orootOrShell){
  return (
    orootOrShell.querySelector("[data-mpr-media]") ||
    orootOrShell.querySelector(".mprOverlayStage__inner") ||
    orootOrShell.querySelector(".mprOverlay__imgStage") ||
    orootOrShell.querySelector("[data-mpr-stage]") ||
    null
  );
}

function mprPlaceLogoInsidePrintBox(shell, { scale = 0.75 } = {}) {
  const printBox = shell.querySelector("[data-mpr-printbox]");
  const box      = shell.querySelector("[data-mpr-logo-box]");
  const img      = shell.querySelector("[data-mpr-logo-img]");
  if (!printBox || !box || !img) return false;

  let b = null;
  try { b = JSON.parse(printBox.dataset.mprBounds || "null"); } catch {}
  if (!b || !(b.width > 2 && b.height > 2)) return false;

  if (!(img.naturalWidth > 0 && img.naturalHeight > 0)) {
    if (!img.dataset.mprFitOnce) {
      img.dataset.mprFitOnce = "1";
      img.addEventListener("load", () => {
        delete img.dataset.mprFitOnce;
        try { mprPlaceLogoInsidePrintBox(shell, { scale }); } catch {}
      }, { once: true });
    }
    return false;
  }

  const stageEl = mprGetStageEl(shell) || printBox.parentElement;
  const parent  = box.offsetParent || stageEl || shell;

  const stageRect  = stageEl?.getBoundingClientRect?.() || { left: 0, top: 0 };
  const parentRect = parent?.getBoundingClientRect?.()  || { left: 0, top: 0 };

  const iw = img.naturalWidth;
  const ih = img.naturalHeight;
  const ar = iw / ih;

  const maxW = b.width * scale;
  const maxH = b.height * scale;

  let w = maxW;
  let h = w / ar;
  if (h > maxH) { h = maxH; w = h * ar; }

  const leftStage = b.left + (b.width  - w) / 2;
  const topStage  = b.top  + (b.height - h) / 2;

  const left = (stageRect.left + leftStage) - parentRect.left;
  const top  = (stageRect.top  + topStage)  - parentRect.top;

  box.style.left   = `${left}px`;
  box.style.top    = `${top}px`;
  box.style.width  = `${w}px`;
  box.style.height = `${h}px`;

  return true;
}



window.mprSyncViewThumbs = function mprSyncViewThumbs(imgSrc) {
  const src = String(imgSrc || "");
  document.querySelectorAll("[data-mpr-viewthumb]").forEach((img) => {
    img.src = src;
  });
};



async function mprSetStageMockup(oroot, mockupUrl) {
  await mprWithBusy(oroot, async () => {
    window.mprSyncViewThumbs(mockupUrl);

    const overlay = mprGetOverlay(oroot);
    const shell = mprGetShell(oroot) || oroot;

    const stageImg =
      overlay.querySelector("[data-mpr-overlay-img]") ||
      overlay.querySelector("[data-mpr-stageimg]") ||
      overlay.querySelector(".mprOverlayStage__img") ||
      overlay.querySelector("img[data-mpr-mainimg]");

    if (!stageImg) return;

    if (!overlay.dataset.mprStageBaseSrc) {
      overlay.dataset.mprStageBaseSrc = stageImg.getAttribute("src") || "";
    }

    overlay.dataset.mprMockupUrl = String(mockupUrl || "");
    overlay.classList.add("has-mockup");

    stageImg.src = mockupUrl;
    await mprWaitImg(stageImg, 20000);

    const layer = shell.querySelector("[data-mpr-logo-layer]") || shell.querySelector(".mprLogoLayer");
    if (layer) layer.hidden = true;

    const printBox = shell.querySelector("[data-mpr-printbox]");
    if (printBox) printBox.hidden = true;
  }, "Applying mockup…");

  return true;
}







function escapeHtml(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function mprGetDecorationChargeVariantId() {
  const id = window.__DECORATION_CHARGE_VARIANT_ID__;
  const n = parseInt(String(id || ""), 10);
  return Number.isFinite(n) && n > 0 ? n : null;
}


function mprMoneyToNumber(txt){
  const s = String(txt || "").replace(/[^\d.]/g, "");
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : 0;
}

function mprFormatMoney(root, dollars){
  const cents = Math.round((dollars || 0) * 100);
  try {
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, window.Shopify.money_format || "${{amount}}");
    }
  } catch(e){}
  return "$" + (cents / 100).toFixed(2);
}


function mprRenderPriceBreakdownHTML(root, productData){
  const overlay = root.closest("[data-mpr-overlay]") || root;

  const { totalQty, bySize } = mprReadSizeQuantities(root);
  const qty = Math.max(1, totalQty || 1);

  const tiersFromDom = mprReadTiersFromDom(root);
  const tierOptIndex = mprFindQuantityTierIndex(productData);
  const tierOptValue = tierOptIndex >= 0 ? mprPickQtyTierValue(productData, qty) : null;

  const sizeIndex = findOptionIndex(productData, ["size", "sizes", "sizing"]);
  const variants = productData?.variants || [];
  const selected = variants.find((v) => v.id === productData.selected_variant_id) || variants[0];

  function unitPriceForSize(sizeValOrNull) {
    if (tierOptIndex >= 0 && tierOptValue) {
      const overrides = { [tierOptIndex]: tierOptValue };
      if (sizeIndex >= 0 && sizeValOrNull != null) overrides[sizeIndex] = sizeValOrNull;

      const v = mprVariantMatchesSelectedWithOverrides(productData, overrides) || selected;
      return mprPriceToDollars(v?.price);
    }


    if (tiersFromDom && tiersFromDom.length) {
      if (sizeIndex >= 0 && sizeValOrNull != null) {
        const v = mprVariantMatchesSelectedWithOverrides(productData, { [sizeIndex]: sizeValOrNull }) || selected;
        return mprTieredPrice(v?.price, qty, tiersFromDom);
      }
      return mprTieredPrice(selected?.price, qty, tiersFromDom);
    }


    if (sizeIndex >= 0 && sizeValOrNull != null) {
      const v = mprVariantMatchesSelectedWithOverrides(productData, { [sizeIndex]: sizeValOrNull }) || selected;
      return mprPriceToDollars(v?.price);
    }

    return mprPriceToDollars(selected?.price);
  }

  const method = mprGetSelectedDecorationMethod(root);
  const numLocs = mprGetSelectedLocationsCount(root) || 1;
  const totalColors = mprGetTotalColorsAcrossSelectedLocations(root) || 1;

  const charges = mprComputePrintChargesBreakdown({
    method,
    numLocs,
    totalColors,
    qty,
  });

  const fm = (dollars) => mprFormatMoney(root, dollars);

  let productTotal = 0;
  let productRowsHtml = "";

  if (sizeIndex >= 0 && bySize && bySize.length) {
    for (let i = 0; i < bySize.length; i++) {
      const row = bySize[i];
      const q = Math.max(0, mprParseQty(row.qty));
      if (!q) continue;

      const p = unitPriceForSize(row.size);
      const line = p * q;
      productTotal += line;

      const sizeLabel = String(row.size || "").toUpperCase();
      productRowsHtml += `
        <tr>
          <td>Product</td>
          <td>${q} (${escapeHtml(sizeLabel)}) × ${escapeHtml(mprMoney(p))}</td>
          <td>${fm(line)}</td>
        </tr>
      `;
    }
  } else {
    const p = unitPriceForSize(null);
    productTotal = p * qty;
    productRowsHtml = `
      <tr>
        <td>Product</td>
        <td>${qty} × ${escapeHtml(mprMoney(p))}</td>
        <td>${fm(productTotal)}</td>
      </tr>
    `;
  }

  const grandTotal = productTotal + (charges?.total || 0);

  const decoLines = (charges?.lines || [])
    .map((l) => {
      return `
        <tr>
          <td>Decoration</td>
          <td>${escapeHtml(l.label)}</td>
          <td>${fm(l.amount)}</td>
        </tr>
      `;
    })
    .join("");

  return `
    <table class="mprBreakTable">
      <thead>
        <tr>
          <th>Line</th>
          <th>Details</th>
          <th>Amount</th>
        </tr>
      </thead>

      <tbody>
        ${productRowsHtml}
        ${decoLines}
        <tr>
          <td>Logo colors</td>
          <td>${totalColors} color(s) across ${numLocs} location(s)</td>
          <td>${fm(0)}</td>
        </tr>
      </tbody>

      <tfoot>
        <tr>
          <th colspan="2">Total</th>
          <th>${fm(grandTotal)}</th>
        </tr>
      </tfoot>
    </table>
    <div class="mprBreakMuted">Color pricing is based on detected logo colors.</div>
  `;
}






function normalizeOptName(s) {
  return normKey(s);
}

function findOptionIndex(productData, names) {
  const opts = productData?.options || [];
  const want = new Set((names || []).map(normKey));
  for (let i = 0; i < opts.length; i++) {
    if (want.has(normKey(opts[i]?.name))) return i;
  }
  return -1;
}

function getVariantOptionValue(variant, optionIndex) {
  if (!variant || optionIndex < 0) return null;
  return variant["option" + (optionIndex + 1)] || null;
}

function $(root, sel) {
  return (root || document).querySelector(sel);
}
function $all(root, sel) {
  return Array.from((root || document).querySelectorAll(sel));
}

const MPR_LOC_COLOR_COUNTS = new WeakMap();
function mprGetLocColorMap(root) {
  const r = root || document;
  let map = MPR_LOC_COLOR_COUNTS.get(r);
  if (!map) {
    map = new Map();
    MPR_LOC_COLOR_COUNTS.set(r, map);
  }
  return map;
}

const MPR_LOC_UPLOAD_GROUPS = new WeakMap();
function mprGetLocUploadGroupMap(root) {
  const r = root || document;
  let map = MPR_LOC_UPLOAD_GROUPS.get(r);
  if (!map) {
    map = new Map();
    MPR_LOC_UPLOAD_GROUPS.set(r, map);
  }
  return map;
}
function mprCanonRoot(root){
  return mprGetShell(root) || root || document;
}




const MPR_LOC_STATE = new WeakMap();
function mprGetLocStateMap(root){
  const r = mprCanonRoot(root);
  let m = MPR_LOC_STATE.get(r);
  if (!m) { m = new Map(); MPR_LOC_STATE.set(r, m); }
  return m;
}




function mprGetActiveLocKey(oroot){
  const root = mprCanonRoot(oroot);
  const viewsWrap = root.querySelector("[data-mpr-views]");
  const active = viewsWrap?.querySelector("[data-mpr-view].is-active");
  return (active?.dataset?.mprLocKey || "").trim() || "front";
}


function mprSetActiveLocKey(oroot, locKey){
  const overlay = mprGetOverlay(oroot);
  if (overlay) overlay.dataset.mprActiveLocKey = String(locKey || "");
}



function mprGetSavedLocState(oroot, locKey){
  return mprGetLocStateMap(oroot).get(String(locKey || "")) || null;
}


function mprSaveLocState(oroot, locKey, patch){
  const key = String(locKey || "");
  const map = mprGetLocStateMap(oroot);
  const cur = map.get(key) || {};
  map.set(key, { ...cur, ...patch });
  return map.get(key);
}



function slugifyViewKey(s) {
  return String(s || "")
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

function parsePlacementMetaFromAlt(alt) {
  const a = String(alt || "").trim();
  if (!a) return null;

  const low = a.toLowerCase();
  if (!low.startsWith("placement:")) return null;

  const rest = a.slice("placement:".length).trim();
  const parts = rest.split(":").map(x => String(x || "").trim()).filter(Boolean);

  if (!parts.length) return { kind: "generic", raw: "" };

  if (parts.length >= 2 && parts[0].toLowerCase() === "color") {
    const view = normalizePlacementKey(parts[1]); 
    return { kind: "view", view, raw: rest };
  }
  const location = normalizePlacementKey(parts[parts.length - 1]);
  return { kind: "location", location, raw: rest };
}


function readLocationsFromMetafield(oroot) {
  const locScript = oroot.querySelector("[data-mpr-locationdecoration]")
    || document.querySelector("[data-mpr-locationdecoration]");
  if (!locScript) return null;

  try {
    const arr = JSON.parse(locScript.textContent || "null");
    if (!Array.isArray(arr)) return null;

    const seen = new Set();
    const out = [];
    for (const row of arr) {


      const raw = row?.locationName ? String(row.locationName).trim() : "";
      if (!raw) continue;

      const cleaned = mprCleanLocationLabel(raw);
      if (!cleaned.key) continue;

      if (seen.has(cleaned.key)) continue;
      seen.add(cleaned.key);
      out.push(cleaned.label);
    }
    return out.length ? out : null;
  } catch {
    return null;
  }
}






function normalizePlacementKey(s) {
  return String(s || "")
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, " ")
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, " ");
}

function findImageForLocation(productData, locationName) {
  const images = Array.isArray(productData?.images) ? productData.images : [];
  if (!images.length) return null;

  const targetLoc = normalizePlacementKey(locationName);

  let best = null;
  let bestScore = -1;

  let generic = null;  
  let anyPlacement = null;

  for (const img of images) {
    const meta = parsePlacementMetaFromAlt(img?.alt);
    if (!meta) continue;

    anyPlacement = anyPlacement || img;

    if (meta.kind === "generic") {
      generic = generic || img;
      continue;
    }

    let score = 0;

    if (meta.kind === "location") {
      const p = meta.location;

      if (p === targetLoc) score += 10;
      if (targetLoc.includes(p) || p.includes(targetLoc)) score += 6;

      if (targetLoc.includes("front") && p.includes("front")) score += 4;
      if (targetLoc.includes("back") && p.includes("back")) score += 4;
      if (targetLoc.includes("wrap") && (p.includes("wrap") || p.includes("around"))) score += 4;
      if (targetLoc.includes("side") && p.includes("side")) score += 3;
    }

    if (meta.kind === "view") {
      const v = meta.view;
      if (targetLoc.includes(v)) score += 2;
    }

    if (score > bestScore) {
      bestScore = score;
      best = img;
    }
  }

  if (bestScore > 0 && best) return best;

  return generic || anyPlacement || null;
}







function mprHasLogo(oroot){
  const layer = oroot.querySelector("[data-mpr-logo-layer]") || oroot.querySelector(".mprLogoLayer");
  const img = oroot.querySelector("[data-mpr-logo-img]");
  return !!(layer && !layer.hidden && img && img.getAttribute("src"));
}

function mprSyncHasLogoClass(oroot){
  mprSetHasLogo(oroot, mprHasLogo(oroot));
}






function mprSaveGlobalLogoColorCount(oroot, count, palette){
  const overlay = mprGetOverlay(oroot);
  if (!overlay) return;

  const n = String(count || 1);

  overlay.dataset.mprLogoColorCount = n;

  overlay.dataset.mprLogoColors = n;

  overlay.__mprLogoColors = parseInt(n, 10) || 1;
  oroot.__mprLogoColors = overlay.__mprLogoColors;

  try {
    sessionStorage.setItem("mpr_logo_color_count", n);
  } catch {}

  const uploadView = overlay.querySelector('[data-mpr-panel-view="upload"]');
  if (uploadView) {
    mprSetColorMeta(uploadView, `Detected colors: ${count || 1}`, palette || []);
  }
}



//


function mprFindImageForColorAndLoc(productData, colorKey, locKey) {
  const images = Array.isArray(productData?.images) ? productData.images : [];
  if (!images.length) return null;

  const wantColor = normToken(colorKey);
  const wantLoc   = normToken(locKey);

  let best = null;
  let bestScore = -1;

  let colorAnyLoc = null; 
  let anyColorLoc = null; 
  let anyPlacement = null;

  for (const img of images) {
    const meta = parseMprAlt(img?.alt); 
    if (!meta) continue;

    anyPlacement = anyPlacement || img;

    const c = normToken(meta.color);
    const l = normToken(meta.loc);

    if (c === wantColor && l === wantLoc) return img; 

    if (c === wantColor && !colorAnyLoc) colorAnyLoc = img;
    if (l === wantLoc && !anyColorLoc) anyColorLoc = img;

    let score = 0;
    if (c === wantColor) score += 10;
    if (l === wantLoc) score += 10;
    if (score > bestScore) {
      bestScore = score;
      best = img;
    }
  }

  return bestScore > 0 ? best : (colorAnyLoc || anyColorLoc || anyPlacement || null);
}

function mprSyncViewsToColor(oroot, productData, colorLabelOrKey) {
  const overlay = mprGetOverlay(oroot) || document;
  const viewsWrap = oroot.querySelector("[data-mpr-views]");
  if (!viewsWrap) return;

  const stageImg =
    overlay.querySelector("[data-mpr-overlay-img]") ||
    overlay.querySelector("[data-mpr-stageimg]") ||
    overlay.querySelector(".mprOverlayStage__img") ||
    overlay.querySelector("img[data-mpr-mainimg]");

  const colorKey = normToken(colorLabelOrKey);

  const btns = viewsWrap.querySelectorAll("[data-mpr-view]");
  btns.forEach((btn) => {
    const locKey = btn.dataset.mprLocKey || "";
    const imgObj = mprFindImageForColorAndLoc(productData, colorKey, locKey);

    const thumbImg = btn.querySelector("img[data-mpr-viewthumb]");
    const full = imgObj?.full || imgObj?.src || imgObj?.url || "";
    const thumb = imgObj?.thumb || full;

    if (thumbImg && thumb) thumbImg.src = thumb;
    if (full) btn.dataset.mprViewFull = full;
  });

  const active = viewsWrap.querySelector("[data-mpr-view].is-active") || viewsWrap.querySelector("[data-mpr-view]");
  if (stageImg && active?.dataset?.mprViewFull) {
    stageImg.src = active.dataset.mprViewFull;
  }
}





// Start


// End

(function () {
const DEFAULTS_BY_COLLECTION = {
// T-Shirts
"527391981885": {
    decos: ["Screen Print"],
    locs: ["Front", "Back", "Sleeve"]
},
// Short Sleeve
"531876000000": {
    decos: ["Screen Print"],
    locs: ["Front", "Back", "Sleeve"]
},

// Long Sleeve
"531877000000": {
    decos: ["Screen Print"],
    locs: ["Front", "Back", "Sleeve"]
},


// Performance T-Shirt
"531877626173": {
    decos: ["Screen Print"],
    locs: ["Front", "Back", "Sleeve"]
},

 // Hoodies & Fleece
"527391850813": {
    decos: ["Embroidery", "Screen Print"],
    locs: ["Front", "Back", "Sleeve"]
},

// Polos
"527391949117": {decos: ["Embroidery", "Screen Print"], locs: ["Front", "Back", "Sleeve"]},

// Performance Polos
"531878000000": {decos: ["Embroidery", "Screen Print"], locs: ["Front", "Back", "Sleeve"]},

// Cotton Polos
"GT35BL7Y": {decos: ["Embroidery", "Screen Print"], locs: ["Front", "Back", "Sleeve"]},

// Golf Polos
"530620842301": {decos: ["Embroidery", "Screen Print"], locs: ["Front", "Back", "Sleeve"]},


// Pullovers
"531879000000": {decos: ["Embroidery", "Screen Print"],
                 locs: ["Front", "Back", "Sleeve"]},

// Quarter & Half Zips
"531878000000": {decos: ["Embroidery", "Screen Print"],
                 locs: ["Front", "Back", "Sleeve"]},

// Full Zips
"535055000000": {decos: ["Embroidery", "Screen Print"],
                 locs: ["Front", "Back", "Sleeve"]},

// 3 in 1 System Jackets
"531879000000": {decos: ["Screen Print"], locs: ["Front", "Back", "Sleeve"]},

// Insulated & Down
"531879000000": {decos: ["Screen Print"], locs: ["Front", "Back", "Sleeve"]},

// Lightweight
"526606205245": {decos: ["Screen Print"],
                 locs: ["Front", "Back", "Sleeve"]},

// Softshell
"531879000000": {decos: ["Embroidery", "Screen Print"],
                 locs: ["Front", "Back", "Sleeve"]},

// Vests
"531880000000": {decos: ["Embroidery", "Screen Print"], locs: ["Front", "Back"]},

// Structured
"530630050109": {decos: ["Embroidery", "Screen Print"], locs: ["Center Front"]},

// Unstructured
"530630082877": {decos: ["Embroidery", "Screen Print"], locs: ["Center Front"]},

// Performance
"532189643069": {decos: ["Embroidery", "Screen Print"], locs: ["Center Front"]},

// Trucker
"532191000000": {decos: ["Embroidery", "Screen Print"], locs: ["Center Front"]},

// Knits
"532192000000": {decos: ["Embroidery", "Screen Print"], locs: ["Cuff (primary)", "Flat (no cuff)"]},

// Backpack
"532192000000": {decos: ["Embroidery", "Screen Print"], locs: ["Upper Front Pocket"]},

// Tote Bag
"527395422525": {decos: ["Embroidery", "Screen Print"], locs: ["Center Front"]},

// Cooler Bag
"532193000000": {decos: ["Embroidery", "Screen Print"], locs: ["Front Pocket"]},

// Duffel Bag
"532193000000": {decos: ["Embroidery", "Screen Print"], locs: ["Top Flap / Lid"]},

// Briefcase
"532193000000": {decos: ["Embroidery", "Screen Print"], locs: ["Center of Front Flap"]},

// Drawstring
"532193000000": {decos: ["Embroidery", "Screen Print"], locs: ["Center Front"]},

// Fanny Pack
"532193000000": {decos: ["Embroidery", "Screen Print"], locs: ["Front Pocket"]},

// Luggage
"532194000000": {decos: ["Embroidery", "Screen Print"], locs: ["Center"]},

// Tumblers
"532194000000": {decos: ["Laser Engraving", "Screen Print", "Digital (UV) Print"],
                 locs: ["1-Side", "2-Side", "Full Wrap"]},

// Vacuum Insulated
"530647000000": {decos: ["Laser Engraving", "Screen Print", "Digital (UV) Print"],
                 locs: ["1-Side", "2-Side", "Full Wrap"]},

// Mugs
"532194361661": {decos: ["Sublimation (for full-color)", "Screen Print (kiln-fired)"],
                 locs: ["1-Side", "2-Side", "Full Wrap"]},

// Water Bottles
"532194000000": {decos: ["Screen Printing (Pad Print)"], locs: ["1-Side", "2-Side", "Full Wrap"]},

// Coasters
"532194000000": {decos: ["Laser, Sublimation, Digital Print"], locs: ["Center / Full Surface"]},

// Gift Sets
"526608400701": {decos: ["Laser Engraving"], locs: ["Lid of the Gift Box"]},

// Food & Gourmet Gifts
"527396143421": {decos: ["Full-Color Print", "Hot Stamp (Foil)"], locs: ["Lid (Center)"]},

// Health & Beauty Travel
"526609383741": {decos: ["Full-Color Digital Print"], locs: ["Front Face"]},

// Sanitizers
"532195000000": {decos: ["Full-Color Digital Print"], locs: ["Front Face"]},

// Home & Office
"527396372797": {decos: ["Embroidery"], locs: ["Dobby Border"]},

// Candles
"532196000000": {decos: ["Pad Print"], locs: ["Container"]},

// Plants
"532196000000": {decos: ["Pad Print"], locs: ["Container"]},

// Food Storage
"532196000000": {decos: ["Laser Engraving", "Pad Print"], locs: ["Lid"]},

// Kitchen Tools
"535055000000": {decos: ["Laser Engraving", "Pad Print"], locs: ["Face"]},

// Small Appliances
"535056000000": {decos: ["Laser Engraving", "Pad Print"], locs: ["Face"]},

// Calenders
"532196000000": {decos: ["Printing", "Debossing", "Foil Stamp"], locs: ["Front Cover", "Header"]},

// Desk
"532196000000": {decos: ["Laser Engraving", "Pad Print"], locs: ["Face"]},

// Journals and Notebook
"527396536637": {decos: ["Printing", "Debossing", "Foil Stamp"], locs: ["Front Cover", "Header"]},

// Lanyards
"532197000000": {decos: ["Dye Sublimation", "Screen Print"], locs: ["Full Strap (Repeating)"]},

// Sunglasses and Eyewear
"532197000000": {decos: ["Pad Printing"], locs: ["Arm (Temple)", "Lens"]},

// Travel
"526607450429": {decos: ["Pad Print", "Hot Stamp"], locs: ["Front Cover", "Corner / Side"]},

// Auto
"526609711421": {decos: ["Screen Print", "Laser Engraving"], locs: ["Full Surface", "Main Body", "Handle"]},

// Plastic Pens
"532197000000": {decos: ["Pad Printing"], locs: ["Barrel (aligned with clip)", "Clip"]},

// Gel Pens
"532197000000": {decos: ["Pad Printing"], locs: ["Barrel (aligned with clip)", "Clip"]},

// Metal Pens
"532196884797": {decos: ["Laser Engraving", "Pad Printing"], locs: ["Barrel (aligned with clip)", "Clip"]},

// Stylus Pens
"532197000000": {decos: ["Laser Engraving", "Pad Printing"], locs: ["Barrel (aligned with clip)", "Clip"]},

// Pencils
"532197000000": {decos: ["Hot Stamping", "Pad Printing"], locs: ["Barrel"]},

// Markers and Highlighters
"532197114173": {decos: ["Full-Color Digital Print", "Pad Printing"], locs: ["Barrel (aligned with clip)", "Clip"]},

// Fitness
"532197000000": {decos: ["Laser Engraving", "Screen Print"], locs: ["Corner"]},

// Towels
"532195000000": {decos: ["Embroidery"], locs: ["Dobby Border"]},

// Towels
"532195000000": {decos: ["Embroidery"], locs: ["Dobby Border"]},

// Umbrellas
"527396766013": {decos: ["Screen Printing"], locs: ["Panel"]},

// Flashlights
"532198000000": {decos: ["Laser Engraving", "Pad Print"], locs: ["Barrel"]},

// Golf Accessories
"535055000000": {decos: ["Pad Print"], locs: ["Flat Face"]},

// Golf Balls
"532198000000": {decos: ["Pad Print"], locs: ["Side"]},

// BBQ & Picnic Sets
"535053000000": {decos: ["Screen Print", "Heat Transfer"], locs: ["Case/Lid"]},

// Chairs
"532198000000": {decos: ["Screen Printing", "Heat Transfer"], locs: ["Headrest Panel", "Back", "Bag"]},

// Outdoor Games
"526611382589": {decos: ["Screen Print", "Hot Stamp"], locs: ["Top Center"]},

// Camping / Tools
"535054000000": {decos: ["Laser Engraving", "Pad Print"], locs: ["Handle"]},

// Cables / Adaptors
"532199000000": {decos: ["Laser Engraving", "Pad Print"], locs: ["Connector Housing"]},

// Chargers / Power Banks
"532199000000": {decos: ["Full-Color Digital", "Pad Print", "Laser Engrave"], locs: ["Largest flat face/panel"]},

// Earbuds / Headphones
"532199000000": {decos: ["Pad Printing", "Full-Color Digital"], locs: ["Charging Case Lid", "Earcup"]},

// Speakers
"532199000000": {decos: ["Pad Print", "Laser Engrave", "Digital Print"], locs: ["Logo Plate / Side Pane"]},

// Tech Accessories
"527397000000": {decos: ["Full-Color Digital", "Pad Printing"], locs: ["Flat face/surface"]},

// Tech Organizers
"535057000000": {decos: ["Screen Print", "Heat Transfer", "Embroidery"], locs: ["Center of flat panel"]},

// Trackers
"532199000000": {decos: ["Full-Color Digital", "Pad Printing"], locs: ["Flat face"]},

// Trackers
"532199000000": {decos: ["Full-Color Digital", "Pad Printing"], locs: ["Flat face"]},

// Trends
"535057000000": {decos: ["Full-Color Digital", "Pad Printing"], locs: ["Corner"]},

// Full Color Retail Boxes
"532199244093": {decos: ["Hot Stamp (Foil)", "Deboss", "Offset Print", "Spot UV"], locs: ["Lid (Top)", "Inside Lid"]},

// Mailers
"532199000000": {decos: ["Screen Print", "Flexography"], locs: ["Front Face"]},

// Gift Bags
"535055000000": {decos: ["Screen Print"], locs: ["Front"]},

// Greeting Cards
"535055000000": {decos: ["Screen Print"], locs: ["Front"]},

// Seals
"535056000000": {decos: ["Screen Print"], locs: ["Front"]},

// Special Packaging
"535056000000": {decos: ["Screen Print"], locs: ["Front"]},

// Table Covers
"532200000000": {decos: ["Dye Sublimation (Full-Color)", "Screen Print"], locs: ["Front Panel", "Full-Bleed"]},

// Floor Mats
"532199000000": {decos: ["Digital Dye Injection (Jet Print)"], locs: ["Entire Top Surface"]},

// Event Displays
"535054000000": {decos: ["Full-Color Digital Print", "Dye Sublimation (Fabric)"], locs: ["Entire Visible Surface"]},

// Trophies and Plaques
"532200000000": {decos: ["Laser Engraving", "Full-Color UV Print"], locs: ["Main Front Face", "Center of Metal Plate"]},

// Recognition Gifts
"532200000000": {decos: ["Laser Engraving", "Sandblasting", "Pad Print"], locs: ["Main Visible Face"]},

// Plush and Nov
"527397257533": {decos: ["Pad Print", "Heat Transfer", "Screen Print"], locs: ["Main Front Face"]}

};

  function pickDefaults(productData) {
    const ids = (productData?.collection_ids || []).map(String);
    for (let i = 0; i < ids.length; i++) {
      const hit = DEFAULTS_BY_COLLECTION[ids[i]];
      if (hit) return hit;
    }
    return { decos: ["Screen Print"], locs: ["Front"] };
  }

  function getVariantImageUrl(variant) {
    const src =
      variant?.featured_image?.src ||
      variant?.featured_media?.preview_image?.src ||
      variant?.image?.src ||
      null;

    if (!src) return null;
    return src.includes("width=") ? src : src + (src.includes("?") ? "&" : "?") + "width=1600";
  }
  

  function syncMediaToVariant(root, variant) {
    const full = getVariantImageUrl(variant);
    if (!full) return;

    const mainImg = $((root || document), "[data-mpr-mainimg]");
    if (mainImg) mainImg.src = full;

    const overlayImg = $(document, "[data-mpr-overlay-img]");
    if (overlayImg) overlayImg.src = full;
  }

  async function fetchColorMap() {
    const url = window.MPR_COLOR_MAP_URL;
    if (!url) return null;

    try {
      const res = await fetch(url, { cache: "force-cache", credentials: "omit" });
      if (!res.ok) return null;
      const raw = await res.json();

      const map = Object.create(null);
      for (const k in (raw || {})) {
        const v = raw[k];
        if (typeof v === "string") map[normKey(k)] = v;
        else if (v && typeof v === "object") map[normKey(k)] = String(v.hex || v.value || "");
      }
      return map;
    } catch {
      return null;
    }
  }

  function findColorOptionIndex(productData) {
    const opts = productData?.options || [];
    for (let i = 0; i < opts.length; i++) {
      const name = String(opts[i]?.name || "").toLowerCase();
      if (name === "color" || name === "colour") return i;
    }
    return -1;
  }

  function getVariantColor(variant, colorIndex) {
    if (!variant || colorIndex < 0) return null;
    return variant["option" + (colorIndex + 1)] || null;
  }

  function buildSwatches({ root, productData, colorMap }) {
    const swatchWrap = $(root, "[data-mpr-swatches]");
    const labelEl = $(root, "[data-mpr-colorlabel]");
    if (!swatchWrap || !labelEl) return;

    swatchWrap.innerHTML = "";

    const colorIndex = findColorOptionIndex(productData);
    if (colorIndex < 0) return;

    const variants = productData?.variants || [];
    const selectedVariant =
      variants.find((v) => v.id === productData.selected_variant_id) || variants[0];

    const selectedColor = getVariantColor(selectedVariant, colorIndex);
    const selectedKey = normKey(selectedColor);
    labelEl.textContent = (selectedColor || "—").toUpperCase();

    const seen = new Set();
    const colors = [];

    for (let i = 0; i < variants.length; i++) {
      const c = getVariantColor(variants[i], colorIndex);
      if (!c) continue;
      const k = normKey(c);
      if (seen.has(k)) continue;
      seen.add(k);
      colors.push(c);
    }

    const frag = document.createDocumentFragment();

    for (let i = 0; i < colors.length; i++) {
      const colorName = colors[i];
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "mpr__swatch";
      btn.setAttribute("aria-label", colorName);

      const key = normKey(colorName);
      const hex = colorMap?.[key] || colorMap?.[key.replace(/\/.*/, "")] || null;
      if (hex) btn.style.background = hex;

      if (key === selectedKey) btn.classList.add("is-active");

      btn.addEventListener("click", () => {
        const kids = swatchWrap.querySelectorAll(".mpr__swatch.is-active");
        for (let j = 0; j < kids.length; j++) kids[j].classList.remove("is-active");
        btn.classList.add("is-active");

        const desired = variants.find(
          (v) => normKey(getVariantColor(v, colorIndex)) === key
        );
        if (!desired) return;

        productData.selected_variant_id = desired.id;
        mprUpdateUnitPriceUI($(document, "[data-mpr-overlay-root]") || root, productData);

        labelEl.textContent = String(colorName).toUpperCase();

        try {
          const url = new URL(window.location.href);
          url.searchParams.set("variant", String(desired.id));
          window.history.replaceState({}, "", url.toString());
        } catch {}

        syncMediaToVariant(root, desired);

        //
        mprSyncViewsToColor($(document, "[data-mpr-overlay-root]") || root, productData, colorName);

      });

      frag.appendChild(btn);
    }

    swatchWrap.appendChild(frag);
  }

  function buildDecorationOptions(root, productData) {
    const wrap = $(root, "[data-mpr-decos]");
    if (!wrap) return;

    const { decos } = pickDefaults(productData);
    wrap.innerHTML = "";

    const frag = document.createDocumentFragment();

    for (let i = 0; i < decos.length; i++) {
      const name = decos[i];
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "mpr__deco" + (i === 0 ? " is-selected" : "");
      btn.textContent = name;

      btn.addEventListener("click", () => {
        const selected = wrap.querySelector(".mpr__deco.is-selected");
        if (selected) selected.classList.remove("is-selected");
        btn.classList.add("is-selected");
      });

      frag.appendChild(btn);
    }

    wrap.appendChild(frag);
  }

  function uniqueValuesFromVariants(variants, optionIndex) {
    const seen = new Set();
    const out = [];
    for (const v of variants || []) {
      const val = getVariantOptionValue(v, optionIndex);
      if (!val) continue;
      const k = normKey(val);
      if (seen.has(k)) continue;
      seen.add(k);
      out.push(val);
    }
    return out;
  }

  function escapeHtml(s) {
    return String(s ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }
  function escapeAttr(s) {
    return escapeHtml(s).replace(/`/g, "&#96;");
  }

  function buildSizeMatrix(root, productData) {
    const grid = $(root, "[data-mpr-sizegrid]");
    if (!grid) return;

    const sec = grid.closest(".mprOverlay__sec");

    const minQty =
      parseInt($(root, "[data-mpr-minqty]")?.textContent || "", 10) ||
      parseInt(productData?.min_qty || productData?.minimum_quantity || "", 10) ||
      24;

    const sizeIndex = findOptionIndex(productData, ["size", "sizes", "sizing"]);

    if (sizeIndex < 0) {
      if (sec) sec.style.display = "";

      grid.innerHTML = `
        <div class="mprOverlay__qtyCell mprOverlay__qtyCell--single">
          <div class="mprOverlay__qtyLabelRow">
            <div class="mprOverlay__qtyLabel">Quantity</div>
          </div>
          <input
            class="mprOverlay__qtyInput"
            type="number"
            inputmode="numeric"
            pattern="[0-9]*"
            min="${minQty}"
            value="${minQty}"
            step="1"
            data-mpr-qty-single
          >
        </div>
      `;

      const input = $(grid, "[data-mpr-qty-single]");
      if (input) {
        const clampMin = () => {
          const v = parseInt(input.value || "", 10);
          if (!Number.isFinite(v) || v < minQty) input.value = String(minQty);
        };
        input.addEventListener("input", clampMin);
        input.addEventListener("blur", clampMin);
      }
      return;
    }

    if (sec) sec.style.display = "";

    let sizes = uniqueValuesFromVariants(productData?.variants, sizeIndex);

    if (!sizes.length && Array.isArray(productData?.options_with_values)) {
      const opt = productData.options_with_values.find((o) => normKey(o?.name) === "size");
      if (opt?.values?.length) sizes = opt.values.slice();
    }

    if (!sizes.length) {
      grid.innerHTML = `
        <div class="mprOverlay__qtyCell mprOverlay__qtyCell--single">
          <div class="mprOverlay__qtyLabelRow">
            <div class="mprOverlay__qtyLabel">Quantity</div>
          </div>
          <input
            class="mprOverlay__qtyInput"
            type="number"
            inputmode="numeric"
            pattern="[0-9]*"
            min="${minQty}"
            value="${minQty}"
            step="1"
            data-mpr-qty-single
          >
          <div class="mprOverlay__qtyHelp">Minimum ${minQty} units</div>
        </div>
      `;
      const input = $(grid, "[data-mpr-qty-single]");
      if (input) {
        input.addEventListener("input", () => {
          const v = parseInt(input.value || "", 10);
          if (!Number.isFinite(v) || v < minQty) input.value = String(minQty);
        });
      }
      return;
    }

    grid.innerHTML = "";
    const frag = document.createDocumentFragment();

    for (let i = 0; i < sizes.length; i++) {
      const label = String(sizes[i] || "").trim();

      const cell = document.createElement("div");
      cell.className = "mprOverlay__qtyCell";
      cell.innerHTML = `
        <div class="mprOverlay__qtyLabelRow">
          <div class="mprOverlay__qtyLabel">${escapeHtml(label)}</div>
        </div>
        <input
          class="mprOverlay__qtyInput"
          type="number"
          min="0"
          inputmode="numeric"
          pattern="[0-9]*"
          step="1"
          data-mpr-size="${escapeAttr(label)}"
        >
      `;
      frag.appendChild(cell);
    }

    grid.appendChild(frag);
  }






function readLocationDecorationArray(oroot) {
  const locScript =
    oroot.querySelector("[data-mpr-locationdecoration]") ||
    document.querySelector("[data-mpr-locationdecoration]");
  if (!locScript) return null;

  try {
    let v = JSON.parse(locScript.textContent || "null");

    if (typeof v === "string") v = JSON.parse(v);

    if (!Array.isArray(v)) return null;
    return v;
  } catch {
    return null;
  }
}






function mprPositionPrintBox(oroot, locationNameOrNull) {
  const stage =
    oroot.querySelector("[data-mpr-media]") ||
    oroot.querySelector(".mprOverlayStage__inner") ||
    oroot.querySelector(".mprOverlay__imgStage") ||
    oroot.querySelector("[data-mpr-stage]");

  const img = oroot.querySelector("[data-mpr-overlay-img]");
  if (!stage || !img) return;

  const areas = mprReadPrintAreas(oroot);
  if (!areas) return;

  const key = mprPickPrintAreaKey(locationNameOrNull, areas);

  const area = areas[key] || areas.front || null;
  if (!area) return;

  const printBox = mprEnsurePrintBox(oroot);
  if (!printBox) return;

  const apply = () => {
    const r = mprGetContainedImageRect(stage, img);

    const x = Number(area.x) || 0;
    const y = Number(area.y) || 0;
    const w = Number(area.w) || 0;
    const h = Number(area.h) || 0;

    const left = r.left + x * r.width;
    const top  = r.top  + y * r.height;
    const pw   = w * r.width;
    const ph   = h * r.height;

    printBox.style.left = left + "px";
    printBox.style.top = top + "px";
    printBox.style.width = pw + "px";
    printBox.style.height = ph + "px";

    printBox.dataset.mprBounds = JSON.stringify({ left, top, width: pw, height: ph });
  };

  if (img.complete) apply();
  else img.addEventListener("load", apply, { once: true });
}

window.mprPositionPrintBox = mprPositionPrintBox;



function mprSnapLogoIntoPrintBox(oroot, locKey) {
  const shell = mprGetShell(oroot) || oroot;

  mprPositionPrintBox(oroot, locKey || "front");

  mprPlaceLogoInsidePrintBox(shell, { scale: 0.75 });

  try { mprSaveLogoRectNorm(shell, locKey); } catch {}
  try { mprSaveLogoRectInPrintBox(oroot); } catch {}
}



function mprGetActiveColorFromProductData(productData) {
  const variants = productData?.variants || [];
  if (!variants.length) return "";

  const selected =
    variants.find((v) => v.id === productData.selected_variant_id) || variants[0];

  const colorIndex = findColorOptionIndex(productData);
  if (colorIndex < 0) return "";

  return getVariantColor(selected, colorIndex) || "";
}




function buildViews(oroot, productData, currentMainImgSrc) {
  const viewsWrap = oroot.querySelector("[data-mpr-views]");
  if (!viewsWrap) return;

  viewsWrap.innerHTML = "";

  const locdecos = readLocationDecorationArray(oroot);
  let locations = [];

  if (Array.isArray(locdecos) && locdecos.length) {
    const seen = new Set();
    for (const row of locdecos) {

      const raw = row?.locationName ? String(row.locationName).trim() : "";
      if (!raw) continue;

      const cleaned = mprCleanLocationLabel(raw);
      if (!cleaned.key) continue;

      if (seen.has(cleaned.key)) continue;
      seen.add(cleaned.key);

      locations.push(cleaned.label);

    }
  }

  if (!locations.length) {
    const metaLocs = readLocationsFromMetafield(oroot); 
    const defaults = pickDefaults(productData);
    locations = (metaLocs || defaults?.locs || []).map(x => String(x).trim()).filter(Boolean);
  }

  if (!locations.length) {
    viewsWrap.closest(".mprOverlayTools__views")?.setAttribute("hidden", "true");
    return;
  } else {
    viewsWrap.closest(".mprOverlayTools__views")?.removeAttribute("hidden");
  }

  const stageImg = oroot.querySelector("[data-mpr-overlay-img]");

  locations.forEach((locationName, idx) => {
    const viewKey = slugifyViewKey(locationName) || `view-${idx + 1}`;

    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "mprOverlay__viewTab mprOverlayTool" + (idx === 0 ? " is-active" : "");
    btn.setAttribute("data-mpr-view", viewKey);

    const cleaned = mprCleanLocationLabel(locationName);
    btn.dataset.mprLocName = cleaned.label;
    btn.dataset.mprLocKey  = cleaned.key;     



    const thumb = document.createElement("span");
    thumb.className = "mprOverlayTool__thumb";
    thumb.setAttribute("aria-hidden", "true");

    const img = document.createElement("img");
    img.className = "mprOverlayTool__img";
    img.setAttribute("data-mpr-viewthumb", "");
    img.alt = "";




    const activeColor =
      mprGetActiveColorFromProductData(productData) ||
      mprGetActiveColorLabel(oroot) ||
      "";


    const imgObj = mprFindImageForColorAndLoc(productData, activeColor, cleaned.key);

    const full = imgObj?.full || imgObj?.src || imgObj?.url || "";
    const thumbSrc = imgObj?.thumb || full || currentMainImgSrc || "";

    img.src = thumbSrc;
    if (full) btn.dataset.mprViewFull = full;


    thumb.appendChild(img);
    btn.appendChild(thumb);

    const txt = document.createElement("span");
    txt.className = "mprOverlayTool__txt";
    txt.textContent = cleaned.label || locationName || "";
    btn.appendChild(txt);
    viewsWrap.appendChild(btn);


  });

  if (!viewsWrap.dataset.mprViewsBound) {
    viewsWrap.dataset.mprViewsBound = "1";



    viewsWrap.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-mpr-view]");
      if (!btn || !viewsWrap.contains(btn)) return;

      const overlay = mprGetOverlay(oroot);
      if (overlay?.dataset?.mprMockupUrl) return;

      const prevBtn = viewsWrap.querySelector("[data-mpr-view].is-active");
      const prevKey = (prevBtn?.dataset?.mprLocKey || "").trim() || "front";
      if (mprHasLogo(mprGetShell(oroot) || oroot)) {
        mprSaveLogoRectNorm(oroot, prevKey);
      }

      viewsWrap.querySelectorAll("[data-mpr-view]").forEach(b => b.classList.remove("is-active"));
      btn.classList.add("is-active");

      const full = btn.dataset.mprViewFull;
      if (stageImg && full) stageImg.src = full;

      const nextKey = (btn.dataset.mprLocKey || "").trim() || "front";
      const locName = btn.dataset.mprLocName || btn.textContent || "";

      mprSetActiveLocKey(oroot, nextKey);
      mprPositionPrintBox(oroot, nextKey || locName);

      mprSwapStageLogoToLoc(oroot, nextKey);

      requestAnimationFrame(() => {
        mprRestoreLogoRectNorm(oroot, nextKey);
      });
    });


  }


  const first = viewsWrap.querySelector("[data-mpr-view].is-active") || viewsWrap.querySelector("[data-mpr-view]");
  if (first?.dataset?.mprViewFull && stageImg) stageImg.src = first.dataset.mprViewFull;
}


function mprBindLogoDragResize(oroot) {
  if (!oroot || oroot.dataset.mprLogoDragBound) return;
  oroot.dataset.mprLogoDragBound = "1";

  const stage =
    oroot.querySelector(".mprOverlayStage__inner") ||
    oroot.querySelector(".mprOverlay__imgStage") ||
    oroot.querySelector("[data-mpr-stage]");

  const layer = oroot.querySelector("[data-mpr-logo-layer]");
  const box = oroot.querySelector("[data-mpr-logo-box]");
  const handle = oroot.querySelector("[data-mpr-logo-handle]");

  if (!stage || !layer || !box || !handle) return;

  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));

  function rectToStyle(r) {
    box.style.left = r.x + "px";
    box.style.top = r.y + "px";
    box.style.width = r.w + "px";
    box.style.height = r.h + "px";
  }

  function getRect() {
    return {
      x: box.offsetLeft,
      y: box.offsetTop,
      w: box.offsetWidth,
      h: box.offsetHeight,
    };
  }

  function clampRect(r) {
    const printBox = oroot.querySelector("[data-mpr-printbox]");
    let b = null;
    try { b = JSON.parse(printBox?.dataset?.mprBounds || "null"); } catch {}
    if (!b) {
      const maxW = stage.clientWidth;
      const maxH = stage.clientHeight;
      const minW = 70, minH = 40;

      r.w = clamp(r.w, minW, maxW);
      r.h = clamp(r.h, minH, maxH);
      r.x = clamp(r.x, 0, maxW - r.w);
      r.y = clamp(r.y, 0, maxH - r.h);
      return r;
    }

    const minW = 70;
    const minH = 40;

    r.w = clamp(r.w, minW, b.width);
    r.h = clamp(r.h, minH, b.height);

    r.x = clamp(r.x, b.left, b.left + b.width - r.w);
    r.y = clamp(r.y, b.top,  b.top  + b.height - r.h);

    return r;
  }


  let drag = null;

  box.addEventListener("pointerdown", (e) => {
    if (e.target.closest?.("[data-mpr-logo-handle], [data-mpr-logo-del]")) return;
    if (layer.hidden) return;

    e.preventDefault();
    box.setPointerCapture(e.pointerId);

    drag = {
      type: "move",
      startX: e.clientX,
      startY: e.clientY,
      start: getRect(),
    };
  });

  handle.addEventListener("pointerdown", (e) => {
    if (layer.hidden) return;

    e.preventDefault();
    e.stopPropagation();
    handle.setPointerCapture(e.pointerId);

    drag = {
      type: "resize",
      startX: e.clientX,
      startY: e.clientY,
      start: getRect(),
    };
  });

  function onMove(e) {
    if (!drag) return;

    const dx = e.clientX - drag.startX;
    const dy = e.clientY - drag.startY;

    if (drag.type === "move") {
      const r = clampRect({
        x: drag.start.x + dx,
        y: drag.start.y + dy,
        w: drag.start.w,
        h: drag.start.h,
      });
      rectToStyle(r);
      return;
    }

    const r = clampRect({
      x: drag.start.x,
      y: drag.start.y,
      w: drag.start.w + dx,
      h: drag.start.h + dy,
    });
    rectToStyle(r);
  }

  function onUp() {
    if (drag) {
      drag = null;
      mprSaveLogoRectNorm(oroot);
    }
  }


  oroot.addEventListener("pointermove", onMove);
  oroot.addEventListener("pointerup", onUp);
  oroot.addEventListener("pointercancel", onUp);
}




function mprBindLogoDelete(anyRoot) {
  const overlay = mprGetOverlay(anyRoot);
  if (!overlay) return;

  if (overlay.dataset.mprLogoDeleteBound === "1") return;
  overlay.dataset.mprLogoDeleteBound = "1";

  overlay.addEventListener(
    "pointerdown",
    (e) => {
      const del = e.target.closest?.("[data-mpr-logo-del]");
      if (!del) return;

      e.preventDefault();
      e.stopPropagation();

      mprClearLogo(overlay);
    },
    true
  );
}



function mprBindBreakModal(oroot) {
  const overlay = mprGetOverlay(oroot);
  if (!overlay || overlay.dataset.mprBreakBound === "1") return;
  overlay.dataset.mprBreakBound = "1";

  const modal = overlay.querySelector("[data-mpr-break-modal]");
  const body  = overlay.querySelector("[data-mpr-break-body]");
  if (!modal || !body) return;

  function getProductDataFromOverlayRoot() {
    const id = overlay?.dataset?.mprActiveId;
    if (!id) return null;
    const dataTag = document.getElementById(`mpr-product-${id}`);
    if (!dataTag) return null;
    try { return JSON.parse(dataTag.textContent || "{}"); }
    catch { return null; }
  }

  overlay.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-mpr-break-toggle]");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const productData = getProductDataFromOverlayRoot();
    if (!productData) return;

    const shell =
      overlay.querySelector("[data-mpr-overlay-root]") ||
      overlay.querySelector(".mprOverlayShell") ||
      overlay;

    body.innerHTML = mprRenderPriceBreakdownHTML(shell, productData);

    if (typeof modal.showModal === "function") modal.showModal();
    else modal.setAttribute("open", "open");
  });

  overlay.addEventListener("click", (e) => {
    const close = e.target.closest("[data-mpr-break-close]");
    if (!close) return;

    e.preventDefault();
    e.stopPropagation();

    if (typeof modal.close === "function") modal.close();
    else modal.removeAttribute("open");
  });

  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      if (typeof modal.close === "function") modal.close();
      else modal.removeAttribute("open");
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    if (modal.hasAttribute("open")) {
      if (typeof modal.close === "function") modal.close();
      else modal.removeAttribute("open");
    }
  });
}







function mprBindRail(oroot){
  const overlay = mprGetOverlay(oroot);
  if (!overlay || overlay.dataset.mprRailBound) return;
  overlay.dataset.mprRailBound = "1";

  const railBtns = Array.from(overlay.querySelectorAll("[data-mpr-rail]"));
  const views = Array.from(overlay.querySelectorAll(".mprPanelView[data-mpr-panel-view]"));

  if (!railBtns.length || !views.length) return;

  function setActive(key){
    railBtns.forEach((b) => {
      const on = b.getAttribute("data-mpr-rail") === key;
      b.classList.toggle("is-active", on);
      b.setAttribute("aria-pressed", on ? "true" : "false");
    });

    views.forEach((v) => {
      const on = v.getAttribute("data-mpr-panel-view") === key;
      v.classList.toggle("is-active", on);
    });
  }

  overlay.addEventListener("click", (e) => {
    const btn = e.target.closest?.("[data-mpr-rail]");
    if (!btn || !overlay.contains(btn)) return;

    e.preventDefault();
    e.stopPropagation();

    const key = btn.getAttribute("data-mpr-rail");
    if (!key) return;
    overlay.classList.remove("is-step-qty");


    if (key === "qty") {
      const locKeys = mprGetUploadedLocKeys(oroot);

      mprWithBusy(oroot, async () => {
        const items = await mprBuildClientPreviewsForLocs(oroot, locKeys);
        mprRenderQtyMockups(oroot, items);
      }, "Preparing previews…");
    }


    overlay.classList.remove("is-step-qty");
    setActive(key);

  });

  const initial =
    overlay.querySelector('[data-mpr-rail].is-active')?.getAttribute("data-mpr-rail") ||
    overlay.querySelector('.mprPanelView.is-active')?.getAttribute("data-mpr-panel-view") ||
    "options";

  setActive(initial);
}



async function mprHandleLocUpload(oroot, locLabel, fileInput){
  const f = fileInput.files && fileInput.files[0];
  if (!f) return;

  const name = (f.name || "").toLowerCase();
  const isSvg = name.endsWith(".svg") || f.type === "image/svg+xml";
  const isImage = (f.type && f.type.startsWith("image/")) || isSvg;

  let count = 1, palette = [];

  if (isImage && !isSvg) {
    const res = await mprCountDominantColorsFromFile(f);
    if (res?.ok) { count = res.colorCount || 1; palette = res.palette || []; }
  }

  fileInput.dataset.mprColorCount = String(count);

  mprGetLocColorMap(oroot).set(locLabel, count);

  const groupEl = fileInput.closest(".mprUploadGroup") || fileInput.closest(".mprUploadPanel") || oroot;
  mprSetColorMeta(groupEl, `Detected colors: ${count}`, palette);

  const qty = mprResolveTotalQtyFromOverlay(oroot, {});
  const method = mprGetSelectedDecorationMethod(oroot);
  const numLocs = mprGetSelectedLocationsCount(oroot) || 1;
  const totalColors = mprGetTotalColorsAcrossSelectedLocations(oroot) || 1;

}





// Box Helpers

function mprReadPrintAreas(oroot) {
  const el =
    oroot.querySelector("[data-mpr-print-areas]") ||
    document.querySelector("[data-mpr-print-areas]");
  if (!el) return null;
  try {
    let v = JSON.parse(el.textContent || "null");
    if (typeof v === "string") v = JSON.parse(v);
    return (v && typeof v === "object") ? v : null;
  } catch {
    return null;
  }
}

function mprGetContainedImageRect(stageEl, imgEl) {
  const W = stageEl.clientWidth || 1;
  const H = stageEl.clientHeight || 1;

  const natW = imgEl.naturalWidth || W;
  const natH = imgEl.naturalHeight || H;

  const scale = Math.min(W / natW, H / natH);
  const w = natW * scale;
  const h = natH * scale;
  const left = (W - w) / 2;
  const top = (H - h) / 2;

  return { left, top, width: w, height: h };
}

function mprEnsurePrintBox(oroot) {
  const media =
    oroot.querySelector("[data-mpr-media]") ||
    oroot.querySelector(".mprOverlayStage__inner") ||
    oroot.querySelector(".mprOverlay__imgStage") ||
    oroot.querySelector("[data-mpr-stage]");

  if (!media) return null;

  let box = oroot.querySelector("[data-mpr-printbox]");
  if (box) return box;

  box = document.createElement("div");
  box.className = "mprPrintArea";
  box.setAttribute("data-mpr-printbox", "1");

  const center = document.createElement("div");
  center.className = "mprPrintArea__center";
  center.setAttribute("data-mpr-printbox-center", "1");

  const uploadBtn = oroot.querySelector("[data-mpr-stage-upload]");
  if (uploadBtn) center.appendChild(uploadBtn);

  box.appendChild(center);

  media.style.position = media.style.position || "relative";
  media.appendChild(box);

  return box;
}


function mprPickPrintAreaKey(locationNameOrNull, areasOrNull) {
  const s = normalizePlacementKey(locationNameOrNull || "");

  const areas = areasOrNull && typeof areasOrNull === "object" ? areasOrNull : null;
  if (areas && s && Object.prototype.hasOwnProperty.call(areas, s)) return s;

  if (areas && s) {
    const keys = Object.keys(areas);
    const hit =
      keys.find(k => normalizePlacementKey(k) === s) ||
      keys.find(k => s.includes(normalizePlacementKey(k))) ||
      keys.find(k => normalizePlacementKey(k).includes(s));
    if (hit) return hit;
  }

  if (s.includes("back")) return "back";
  if (s.includes("sleeve")) return "sleeve";
  if (s.includes("front") || s.includes("chest")) return "front";
  return "front";
}




function mprResetLogoToPrintBox(oroot) {
  const stage =
    oroot.querySelector(".mprOverlayStage__inner") ||
    oroot.querySelector(".mprOverlay__imgStage") ||
    oroot.querySelector("[data-mpr-stage]");

  const box = oroot.querySelector("[data-mpr-logo-box]");
  const printBox = oroot.querySelector("[data-mpr-printbox]");
  if (!stage || !box || !printBox) return;

  let b = null;
  try { b = JSON.parse(printBox.dataset.mprBounds || "null"); } catch {}
  if (!b) return;

  const targetW = Math.max(70, b.width * 0.7);
  const targetH = Math.max(40, b.height * 0.7);

  const left = b.left + (b.width - targetW) / 2;
  const top  = b.top  + (b.height - targetH) / 2;

  box.style.left = left + "px";
  box.style.top = top + "px";
  box.style.width = targetW + "px";
  box.style.height = targetH + "px";

  mprSaveLogoRectNorm(oroot);
}











  function openOverlay(productData, currentMainImgSrc, colorMap) {
    const overlay = $(document, "[data-mpr-overlay]");
    if (!overlay) return;

    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    document.body.classList.add("mprOverlay-lock");

    const title = $(overlay, "[data-mpr-overlay-title]");
    if (title) title.textContent = productData.title || "";

    const img = $(overlay, "[data-mpr-overlay-img]");
    if (img) img.src = currentMainImgSrc || img.src || "";

    mprSyncViewThumbs(currentMainImgSrc);

    const oroot =
      $(document, "[data-mpr-overlay-root]") ||
      $(document, "[data-mpr-overlay]") ||
      document;

    buildViews(oroot, productData, currentMainImgSrc);

    const activeColor = mprGetActiveColorFromProductData(productData) || "";
    if (activeColor) {
    mprSyncViewsToColor(oroot, productData, activeColor);
    }


    mprPositionPrintBox(oroot, "front");

    const stage =
      oroot.querySelector("[data-mpr-media]") ||
      oroot.querySelector(".mprOverlayStage__inner") ||
      oroot.querySelector(".mprOverlay__imgStage") ||
      oroot.querySelector("[data-mpr-stage]");



    if (stage && !stage.dataset.mprPrintObs) {
      stage.dataset.mprPrintObs = "1";
      const ro = new ResizeObserver(() => {
        const activeView = oroot.querySelector("[data-mpr-view].is-active");
        const loc = activeView?.dataset?.mprLocName || "front";
        mprPositionPrintBox(oroot, loc);
      });
      ro.observe(stage);
    }



    mprBindRail(oroot);

    //
    mprBindWebsiteLogoInput(overlay);

    mprBuildUploadGroups(oroot);

    mprBindUnifiedUploads(overlay);


    mprBindLogoDragResize(oroot);

    mprBindLogoDelete(oroot); 
    mprBindBreakModal(oroot);

    mprSetHasLogo(oroot, !$(oroot, "[data-mpr-logo-layer]")?.hidden);

    mprSyncHasLogoClass(oroot);



    const qtyTotal = mprResolveTotalQtyFromOverlay(oroot, productData);
    const chosenMethod = ($(oroot, ".mpr__deco.is-selected")?.textContent || "").trim();
    const locationsWithColors = mprReadSelectedLocationsWithColors(oroot);
    mprComputeDecorationCharge({ method: chosenMethod, locations: locationsWithColors, qty: qtyTotal });
    buildSwatches({ root: oroot, productData, colorMap });
    buildDecorationOptions(oroot, productData);
    buildSizeMatrix(oroot, productData);
    mprAttachQtyGate(oroot, productData);
    mprUpdateUnitPriceUI(oroot, productData);
    mprUpdateCheckoutTotalsUI(oroot, productData);
  }

  function closeOverlay() {
    const overlay = $(document, "[data-mpr-overlay]");
    if (!overlay) return;

    if (overlay.dataset.mprClientPreviewUrl) {
      mprRevokeObjectUrlSafe(overlay.dataset.mprClientPreviewUrl);
      delete overlay.dataset.mprClientPreviewUrl;
    }

    overlay.__mprWorkerPromise = null;

    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
    document.body.classList.remove("mprOverlay-lock");
  }


  async function boot(root) {
    const id = root.getAttribute("data-mpr");
    const dataTag = document.getElementById(`mpr-product-${id}`);
    if (!dataTag) return;

    let productData;
    try {
      productData = JSON.parse(dataTag.textContent || "{}");
    } catch {
      return;
    }
    const colorMap = await fetchColorMap();

    buildSwatches({ root, productData, colorMap });
    buildDecorationOptions(root, productData);

    const variants = productData?.variants || [];
    const selectedVariant =
      variants.find((v) => v.id === productData.selected_variant_id) || variants[0];
    if (selectedVariant) syncMediaToVariant(root, selectedVariant);

    const cta = $(root, "[data-mpr-cta]");
    if (cta) {

      cta.addEventListener("click", () => {
        const mainImg = $(root, "[data-mpr-mainimg]");
        const overlay = document.querySelector("[data-mpr-overlay]");
        if (overlay) overlay.dataset.mprActiveId = root.getAttribute("data-mpr") || "";
        openOverlay(productData, mainImg?.src, colorMap);
      });

    }

    document.addEventListener("click", (e) => {
      if (e.target && e.target.closest && e.target.closest("[data-mpr-overlay-close]")) closeOverlay();
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    const nodes = document.querySelectorAll("[data-mpr]");
    for (let i = 0; i < nodes.length; i++) boot(nodes[i]);
  });

  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target && e.target.querySelector && e.target.querySelector("[data-mpr]");
    if (root) boot(root);
  });
})();



(function attachZoom() {
  const MIN = 0.5;
  const MAX = 2.0;
  const STEP = 0.1;
  const HOLD_MS = 55;
  const BASE_FIT = 2.25;

  function clamp(n, a, b) {
    return n < a ? a : n > b ? b : n;
  }

  function getZoom(root) {
    const z = parseFloat(root.getAttribute("data-mpr-zoom-val") || String(MIN));
    return Number.isFinite(z) ? z : MIN;
  }

  function setZoom(root, img, pctEl, z) {
    const next = clamp(z, MIN, MAX);
    root.setAttribute("data-mpr-zoom-val", String(next));

    const media = img.closest?.("[data-mpr-media]") || img;
    media.style.transformOrigin = "50% 50%";
    media.style.transform = `scale(${next * BASE_FIT})`;

    pctEl.textContent = `${Math.round(next * 100)}%`;
  }

  document.addEventListener("click", (e) => {
    const btnIn = e.target.closest?.("[data-mpr-zoom-in]");
    const btnOut = e.target.closest?.("[data-mpr-zoom-out]");
    if (!btnIn && !btnOut) return;

    const root = e.target.closest?.("[data-mpr-overlay-root]");
    if (!root) return;

    const img = $(root, "[data-mpr-overlay-img]");
    const pctEl = $(root, "[data-mpr-zoom-pct]");
    if (!img || !pctEl) return;

    const cur = getZoom(root);
    setZoom(root, img, pctEl, btnIn ? cur + STEP : cur - STEP);
  });

  let holdTimer = null;

  function startHold(e, dir) {
    const root = e.target.closest?.("[data-mpr-overlay-root]");
    if (!root) return;

    const img = $(root, "[data-mpr-overlay-img]");
    const pctEl = $(root, "[data-mpr-zoom-pct]");
    if (!img || !pctEl) return;

    holdTimer = window.setInterval(() => {
      const cur = getZoom(root);
      setZoom(root, img, pctEl, cur + dir * STEP);
    }, HOLD_MS);
  }

  function stopHold() {
    if (holdTimer) {
      clearInterval(holdTimer);
      holdTimer = null;
    }
  }

  document.addEventListener("pointerdown", (e) => {
    if (e.target.closest?.("[data-mpr-zoom-in]")) startHold(e, +1);
    else if (e.target.closest?.("[data-mpr-zoom-out]")) startHold(e, -1);
  });
  document.addEventListener("pointerup", stopHold);
  document.addEventListener("pointercancel", stopHold);
  document.addEventListener("pointerleave", stopHold);

  document.addEventListener("click", (e) => {
    if (!e.target.closest?.("[data-mpr-cta]")) return;

    const overlayRoot = $(document, "[data-mpr-overlay-root]");
    if (!overlayRoot) return;

    const img = $(overlayRoot, "[data-mpr-overlay-img]");
    const pctEl = $(overlayRoot, "[data-mpr-zoom-pct]");
    if (!img || !pctEl) return;

    setZoom(overlayRoot, img, pctEl, getZoom(overlayRoot));
  });
})();

async function mprCountDominantColorsFromFile(file, opts) {
  opts = opts || {};
  const snapBlack = opts.snapBlack ?? 22;
  const snapWhite = opts.snapWhite ?? 250;
  const mergePasses = opts.mergePasses || 2;
  const targetMax = opts.targetMax || 192;
  const alphaCutoff = opts.alphaCutoff ?? 16;
  const quantStep = opts.quantStep || 30;
  const minShare = opts.minShare || 0.01;
  const mergeDist = opts.mergeDist || 42;

  if (!file || !file.type || !file.type.startsWith("image/")) {
    return { ok: false, reason: "not-image", colorCount: 0, palette: [] };
  }

  let bitmap;
  try {
    bitmap = await createImageBitmap(file);
  } catch {
    return { ok: false, reason: "decode-failed", colorCount: 0, palette: [] };
  }


  const scale = Math.min(1, targetMax / Math.max(bitmap.width, bitmap.height));
  const w = Math.max(1, Math.round(bitmap.width * scale));
  const h = Math.max(1, Math.round(bitmap.height * scale));

  const canvas = document.createElement("canvas");
  canvas.width = w;
  canvas.height = h;
  const ctx = canvas.getContext("2d", { willReadFrequently: true });
  if (!ctx) return { ok: false, reason: "no-ctx", colorCount: 0, palette: [] };

  ctx.clearRect(0, 0, w, h);
  ctx.drawImage(bitmap, 0, 0, w, h);

  const img = ctx.getImageData(0, 0, w, h);
  const data = img.data;

  function q(v) {
    if (v <= snapBlack) return 0;
    if (v >= snapWhite) return 255;
    return Math.max(0, Math.min(255, Math.round(v / quantStep) * quantStep));
  }

  function rgbToKey(r, g, b) {
    return (r << 16) | (g << 8) | b;
  }
  function keyToRgb(key) {
    return { r: (key >> 16) & 255, g: (key >> 8) & 255, b: key & 255 };
  }
  function rgbToHex(r, g, b) {
    const to2 = (n) => n.toString(16).padStart(2, "0");
    return ("#" + to2(r) + to2(g) + to2(b)).toUpperCase();
  }
  function dist(a, b) {
    const dr = a.r - b.r,
      dg = a.g - b.g,
      db = a.b - b.b;
    return Math.sqrt(dr * dr + dg * dg + db * db);
  }

  const counts = new Map();
  let total = 0;

  for (let i = 0; i < data.length; i += 4) {
    const a = data[i + 3];
    if (a < alphaCutoff) continue;

    const r = q(data[i]);
    const g = q(data[i + 1]);
    const b = q(data[i + 2]);

    const key = rgbToKey(r, g, b);
    counts.set(key, (counts.get(key) || 0) + 1);
    total++;
  }

  if (!total || counts.size === 0) return { ok: true, colorCount: 0, palette: [] };

  let items = Array.from(counts.entries())
    .map(([key, pixels]) => ({ key, pixels, share: pixels / total, rgb: keyToRgb(key) }))
    .filter((x) => x.share >= minShare)
    .sort((a, b) => b.pixels - a.pixels);

  if (!items.length) {
    items = Array.from(counts.entries())
      .map(([key, pixels]) => ({ key, pixels, share: pixels / total, rgb: keyToRgb(key) }))
      .sort((a, b) => b.pixels - a.pixels)
      .slice(0, 8);
  }

  function mergeOnce(list) {
    const merged = [];
    for (const it of list) {
      let bestIdx = -1;
      let bestD = Infinity;

      for (let i = 0; i < merged.length; i++) {
        const d = dist(it.rgb, merged[i].rgb);
        if (d < bestD) {
          bestD = d;
          bestIdx = i;
        }
      }

      if (bestIdx >= 0 && bestD <= mergeDist) {
        const m = merged[bestIdx];
        const tot = m.pixels + it.pixels;
        m.rgb = {
          r: Math.round((m.rgb.r * m.pixels + it.rgb.r * it.pixels) / tot),
          g: Math.round((m.rgb.g * m.pixels + it.rgb.g * it.pixels) / tot),
          b: Math.round((m.rgb.b * m.pixels + it.rgb.b * it.pixels) / tot),
        };
        m.pixels = tot;
      } else {
        merged.push({ rgb: { ...it.rgb }, pixels: it.pixels });
      }
    }

    merged.sort((a, b) => b.pixels - a.pixels);
    return merged;
  }

  let merged = items.map((x) => ({ rgb: x.rgb, pixels: x.pixels }));
  for (let p = 0; p < mergePasses; p++) merged = mergeOnce(merged);

  const palette = merged.slice(0, 10).map((m) => ({
    hex: rgbToHex(m.rgb.r, m.rgb.g, m.rgb.b),
    pixels: m.pixels,
  }));

  return { ok: true, colorCount: merged.length, palette };
}

function mprEnsureColorMetaEl(groupEl) {
  let el = groupEl.querySelector("[data-mpr-colormeta]");
  if (el) return el;

  const body = groupEl.querySelector(".mprUploadGroup__body") || groupEl;
  el = document.createElement("div");
  el.className = "mprUploadColorMeta";
  el.setAttribute("data-mpr-colormeta", "1");
  el.textContent = "";
  body.appendChild(el);
  return el;
}


function mprEnsureStageFileInput(oroot) {
  let input = oroot.querySelector("[data-mpr-stage-file]");
  if (input) return input;

  input = document.createElement("input");
  input.type = "file";
  input.accept = "image/*,.svg"; 
  input.hidden = true;
  input.setAttribute("data-mpr-stage-file", "1");
  oroot.appendChild(input);

  return input;
}












function mprGetShell(oroot) {
  return oroot?.closest?.(".mprOverlayShell") || oroot;
}

function mprGetOverlay(oroot) {
  return (
    oroot?.closest?.("[data-mpr-overlay]") ||
    document.querySelector("[data-mpr-overlay]") ||
    oroot
  );
}

function mprSetHasLogo(oroot, has) {
  const overlay = mprGetOverlay(oroot);
  if (!overlay) return;

  overlay.classList.toggle("has-logo", !!has);

  const nextBtn = overlay.querySelector("[data-mpr-next]") || overlay.querySelector(".mprOverlayTop__next");
  if (nextBtn) nextBtn.disabled = !has;

  const uploadBtn = overlay.querySelector("[data-mpr-stage-upload]");
  if (uploadBtn) uploadBtn.toggleAttribute("hidden", !!has);
}



//

function mprCenterLogoBoxInPrintBox(oroot) {
  const box = oroot.querySelector("[data-mpr-logo-box]");
  const printBox = oroot.querySelector("[data-mpr-printbox]");
  if (!box || !printBox) return false;

  const op = box.offsetParent || box.parentElement;
  if (!op) return false;

  const opRect = op.getBoundingClientRect();
  const pbRect = printBox.getBoundingClientRect();

  if (!(pbRect.width > 1 && pbRect.height > 1)) return false;


  let targetW = Math.max(70, pbRect.width * 0.7);
  let targetH = Math.max(40, pbRect.height * 0.7);
  targetW = Math.min(targetW, pbRect.width);
  targetH = Math.min(targetH, pbRect.height);

  const left = (pbRect.left - opRect.left) + (pbRect.width - targetW) / 2;
  const top  = (pbRect.top  - opRect.top)  + (pbRect.height - targetH) / 2;

  

  box.style.left = left + "px";
  box.style.top = top + "px";
  box.style.width = targetW + "px";
  box.style.height = targetH + "px";

  mprSaveLogoRectNorm(oroot);
  return true;
}



function mprSwapStageLogoToLoc(oroot, locKey){
  const shell = mprGetShell(oroot);
  const layer = shell.querySelector("[data-mpr-logo-layer]") || shell.querySelector(".mprLogoLayer");
  const img   = shell.querySelector("[data-mpr-logo-img]");

  if (!layer || !img) return;

  const st = mprGetSavedLocState(oroot, locKey);

  if (st?.dataUrl) {
    img.src = st.dataUrl;
    layer.hidden = false;

    mprSetHasLogo(mprGetOverlay(shell), true);

    requestAnimationFrame(() => mprRestoreLogoRectNorm(shell));
  } else {
    img.removeAttribute("src");
    layer.hidden = true;
    mprSetHasLogo(mprGetOverlay(shell), false);
  }

  mprSyncHasLogoClass(shell);
}






function mprApplyLogoFromDataUrl(oroot, dataUrl) {
  const shell = mprGetShell(oroot);

  const overlay = mprGetOverlay(shell);
  const activeView =
    overlay?.querySelector("[data-mpr-view].is-active") ||
    overlay?.querySelector("[data-mpr-view]");

  const locKey =
    (activeView?.dataset?.mprLocKey || overlay?.dataset?.mprActiveLocKey || "front").trim() || "front";

  mprSetActiveLocKey(shell, locKey);
  mprSaveLocState(shell, locKey, { dataUrl });

  const layer = shell.querySelector("[data-mpr-logo-layer]") || shell.querySelector(".mprLogoLayer");
  const img = shell.querySelector("[data-mpr-logo-img]");
  if (!layer || !img) return;

  img.onload = () => {
    const locName = activeView?.dataset?.mprLocName || (activeView?.textContent || "front").trim() || "front";
    mprPositionPrintBox(shell, locKey || locName);

    let tries = 0;
    const MAX = 120;

    (function tick() {
      tries++;
      if (mprPlaceLogoInsidePrintBox(shell, { scale: 0.75 })) {
        mprSaveLogoRectNorm(shell); 
        return;
      }
      if (tries < MAX) requestAnimationFrame(tick);
    })();
  };

  img.src = dataUrl;
  layer.hidden = false;

  mprSetHasLogo(mprGetOverlay(shell), true);
  mprSyncHasLogoClass(shell);
}




function mprGetLogoEls(oroot) {
  const layer = oroot.querySelector("[data-mpr-logo-layer]");
  const box = oroot.querySelector("[data-mpr-logo-box]");
  const img = oroot.querySelector("[data-mpr-logo-img]");
  const file = oroot.querySelector("[data-mpr-stage-file]");
  const uploadBtn = oroot.querySelector("[data-mpr-stage-upload]");
  return { layer, box, img, file, uploadBtn };
}




function mprClearLogo(anyRoot) {
  const overlay = mprGetOverlay(anyRoot);
  if (!overlay) return;

  const shell = mprGetShell(overlay);

  const layer = shell.querySelector("[data-mpr-logo-layer]");
  const img = shell.querySelector("[data-mpr-logo-img]");
  const file = shell.querySelector("[data-mpr-stage-file]");

  if (img) img.removeAttribute("src");
  if (file) file.value = "";
  if (layer) layer.hidden = true;

  mprSetHasLogo(overlay, false);
}










function mprSetColorMeta(groupEl, text, palette) {
  const meta = mprEnsureColorMetaEl(groupEl);
  meta.textContent = text || "";

  const existing = groupEl.querySelector("[data-mpr-palette]");
  if (existing) existing.remove();

  if (palette && palette.length) {
    const row = document.createElement("div");
    row.className = "mprUploadPalette";
    row.setAttribute("data-mpr-palette", "1");
    row.innerHTML = palette
      .slice(0, 6)
      .map((p) => `<span class="mprUploadChip" title="${p.hex}" style="background:${p.hex}"></span>`)
      .join("");
    meta.insertAdjacentElement("afterend", row);
  }
}

function mprGetMinQty(root, productData) {
  const fromDom = parseInt($(root, "[data-mpr-minqty]")?.textContent || "", 10);
  if (Number.isFinite(fromDom) && fromDom > 0) return fromDom;

  const fromData = parseInt(productData?.min_qty || productData?.minimum_quantity || "", 10);
  if (Number.isFinite(fromData) && fromData > 0) return fromData;

  return 24;
}


function mprGetSizeInputs(root) {
  const grid = $(root, "[data-mpr-sizegrid]");
  if (!grid) return [];
  return Array.from(grid.querySelectorAll('input[data-mpr-size], input[data-mpr-qty-single]'));
}

function mprParseQty(v) {
  const n = parseInt(String(v || "").trim(), 10);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

function mprReadSelectedLocationsWithColors(root) {
  const pills = $all(root, ".mprPlacePill.is-active");
  const locs = pills.map((p) => p.getAttribute("data-mpr-loc")).filter(Boolean);

  return locs.map((loc) => {
    const fileInput = root.querySelector(`input[type="file"][data-mpr-upload="${CSS.escape(loc)}"]`);
    const nRaw = fileInput?.dataset?.mprColorCount || "";
    const n = parseInt(nRaw, 10);
    const colors = Number.isFinite(n) && n > 0 ? n : 1;
    return { name: loc, colors };
  });
}

function mprComputeDecorationCharge({ method, locations, qty }) {
  const quantity = Math.max(1, qty || 1);
  const m = String(method || "").trim();
  if (!m) return 0;

  const emb = /embriodery|embroidery/i.test(m);
  const printLike = /print/i.test(m) && !emb;

  const numLocs = locations && locations.length ? locations.length : 1;

  const totalColors =
    (locations || []).reduce((sum, loc) => {
      const n = parseInt(loc?.colors, 10);
      return sum + (Number.isFinite(n) && n > 0 ? n : 1);
    }, 0) || 1;

  const extraColors = Math.max(totalColors - numLocs, 0);
  const extraLocations = Math.max(numLocs - 1, 0);

  if (emb) return 4.95 * numLocs * quantity;

  if (printLike) {
    let total = 0;
    total += 40;
    total += 15 * extraColors;
    total += 15 * extraLocations;
    total += 0.55 * extraColors * quantity;
    total += 2.51 * extraLocations * quantity;
    return total;
  }

  return 0;
}

function mprTotalQty(root) {
  const inputs = mprGetSizeInputs(root);
  let sum = 0;
  for (let i = 0; i < inputs.length; i++) sum += mprParseQty(inputs[i].value);
  return sum;
}

function mprResolveTotalQtyFromOverlay(root, productData) {
  const total = mprTotalQty(root);
  return Math.max(1, total || 1);
}

function mprEnsureMinNote(root) {
  const grid = $(root, "[data-mpr-sizegrid]");
  if (!grid) return null;

  let el = $(root, "[data-mpr-minnote]");
  if (el) return el;

  el = document.createElement("div");
  el.className = "mprQtyMinNote";
  el.setAttribute("data-mpr-minnote", "1");

  grid.insertAdjacentElement("afterend", el);
  return el;
}


function mprSetAddToCartEnabled(root, enabled, reasonText) {
  const btn = $(root, "[data-mpr-addtocart]") || $(document, "[data-mpr-addtocart]");
  if (!btn) return;

  btn.disabled = !enabled;
  btn.classList.toggle("is-disabled", !enabled);
  btn.dataset.mprDisabledReason = enabled ? "" : (reasonText || "Minimum quantity not met");
}

function mprUpdateQtyGate(root, productData) {
  const minQty = mprGetMinQty(root, productData);
  const total = mprTotalQty(root);

  const minEl = mprEnsureMinNote(root);
  if (minEl) {
    minEl.innerHTML = `Minimum order qty: <strong>${minQty}</strong>`;
  }

  const totalEl = $(root, "[data-mpr-qty-totalline]");
  if (totalEl) {
    totalEl.innerHTML = `Total qty: <strong>${total}</strong>`;
  }

  mprSetAddToCartEnabled(
    root,
    total >= minQty,
    `Minimum ${minQty} total units required (current total ${total}).`
  );

  root.classList.toggle("qty-ok", total >= minQty);
  root.classList.toggle("qty-bad", total < minQty);

  return { total, minQty, ok: total >= minQty };
}


function mprAttachQtyGate(root, productData) {
  const inputs = mprGetSizeInputs(root);
  if (!inputs.length) return;

  const onChange = () => {
    for (let i = 0; i < inputs.length; i++) {
      const inp = inputs[i];
      const n = parseInt(inp.value || "", 10);
      if (!Number.isFinite(n) || n < 0) inp.value = "";
    }

    mprUpdateQtyGate(root, productData);
    mprUpdateUnitPriceUI(root, productData);
    mprUpdateCheckoutTotalsUI(root, productData);
  };

  for (let i = 0; i < inputs.length; i++) {
    const inp = inputs[i];
    inp.setAttribute("min", "0");
    inp.addEventListener("input", onChange);
    inp.addEventListener("blur", onChange);
  }

  onChange();

  const btn = $(root, "[data-mpr-addtocart]") || $(document, "[data-mpr-addtocart]");
  if (btn && !btn.dataset.mprQtyGateBound) {
    btn.dataset.mprQtyGateBound = "1";
    btn.addEventListener(
      "click",
      (e) => {
        const gate = mprUpdateQtyGate(root, productData);
        if (!gate.ok) {
          e.preventDefault();
          e.stopPropagation();
          alert(`Please enter at least ${gate.minQty} total units across sizes (current total ${gate.total}).`);
        }
      },
      true
    );
  }
}

function mprMoney(n) {
  const cur = window.Shopify?.currency?.active || "USD";
  try {
    return new Intl.NumberFormat(undefined, { style: "currency", currency: cur }).format(n);
  } catch {
    return "$" + Number(n || 0).toFixed(2);
  }
}

function mprPriceToDollars(v) {
  if (v == null) return 0;
  if (typeof v === "number") return v >= 100 ? v / 100 : v;
  const n = parseFloat(String(v));
  return Number.isFinite(n) ? n : 0;
}

function mprReadTiersFromDom(root) {
  const el =
    $(root, "[data-mpr-tier-json]") ||
    root?.closest?.("[data-mpr]")?.querySelector?.("[data-mpr-tier-json]") ||
    $(document, "[data-mpr-tier-json]");

  if (!el) return null;

  try {
    let raw = (el.textContent || "").trim();
    if (!raw) return null;

    let data = JSON.parse(raw);
    if (typeof data === "string") data = JSON.parse(data);
    if (!Array.isArray(data)) return null;

    const tiers = data
      .map((t) => ({
        min: parseInt(t?.min_qty ?? t?.min ?? t?.qty ?? "", 10),
        price: mprPriceToDollars(t?.price),
      }))
      .filter((t) => Number.isFinite(t.min) && t.min > 0 && Number.isFinite(t.price) && t.price > 0)
      .sort((a, b) => a.min - b.min);

    return tiers.length ? tiers : null;
  } catch {
    return null;
  }
}

function mprTieredPrice(base, totalQty, tiers) {
  const b = mprPriceToDollars(base);
  if (!tiers || !tiers.length) return b;
  let chosen = null;
  for (let i = 0; i < tiers.length; i++) if (totalQty >= tiers[i].min) chosen = tiers[i];
  return chosen ? chosen.price : b;
}

function mprFindQuantityTierIndex(productData) {
  const opts = productData?.options || [];
  for (let i = 0; i < opts.length; i++) {
    const name = String(opts[i]?.name || "").toLowerCase();
    if (name === "quantity tier" || name === "qty tier" || name === "tier") return i;
  }
  return -1;
}

function mprTierMinFromValue(v) {
  const m = String(v || "").match(/(\d+)/);
  return m ? parseInt(m[1], 10) : null;
}

function mprPickQtyTierValue(productData, totalQty) {
  const idx = mprFindQuantityTierIndex(productData);
  if (idx < 0) return null;

  const values = (productData.options[idx]?.values || [])
    .map((v) => ({ v: String(v), min: mprTierMinFromValue(v) }))
    .filter((x) => Number.isFinite(x.min))
    .sort((a, b) => a.min - b.min);

  if (!values.length) return null;

  let chosen = values[0].v;
  for (let i = 0; i < values.length; i++) if (totalQty >= values[i].min) chosen = values[i].v;
  return chosen;
}

function mprVariantMatchesSelectedWithOverrides(productData, overrides) {
  const variants = productData?.variants || [];
  if (!variants.length) return null;

  const selected = variants.find((v) => v.id === productData.selected_variant_id) || variants[0];
  const optCount = (productData?.options || []).length;
  const getOpt = (v, i) => (v ? v["option" + (i + 1)] : null);

  const selectedKeys = new Array(optCount);
  for (let i = 0; i < optCount; i++) selectedKeys[i] = normKey(getOpt(selected, i));

  for (let vi = 0; vi < variants.length; vi++) {
    const v = variants[vi];
    let ok = true;

    for (let i = 0; i < optCount; i++) {
      const want = overrides && Object.prototype.hasOwnProperty.call(overrides, i)
        ? overrides[i]
        : getOpt(selected, i);

      if (normKey(getOpt(v, i)) !== normKey(want)) { ok = false; break; }
    }

    if (ok) return v;
  }

  return null;
}

function mprSetUnitPriceLabel(root, text) {
  const valueEl = $(root, "[data-mpr-unitprice]");
  if (!valueEl) return;

  const labelEl = $(root, "[data-mpr-unitprice-label]") || valueEl.previousElementSibling;
  if (!labelEl) return;

  const t = String(text || "").trim();
  labelEl.textContent = t.endsWith(":") ? t : `${t}:`;
}

function mprReadSizeQuantities(root) {
  const grid = $(root, "[data-mpr-sizegrid]");
  if (!grid) return { totalQty: 0, bySize: [] };

  const single = grid.querySelector("input[data-mpr-qty-single]");
  if (single) {
    const q = mprParseQty(single.value);
    return { totalQty: q, bySize: [] };
  }

  const inputs = Array.from(grid.querySelectorAll("input[data-mpr-size]"));
  const bySize = [];
  let totalQty = 0;

  for (let i = 0; i < inputs.length; i++) {
    const inp = inputs[i];
    const size = inp.getAttribute("data-mpr-size") || "";
    const qty = mprParseQty(inp.value);
    if (qty > 0) bySize.push({ size, qty });
    totalQty += qty;
  }
  return { totalQty, bySize };
}

function mprUpdateUnitPriceUI(root, productData) {
  const unitEl = $(root, "[data-mpr-unitprice]");
  if (!unitEl) return;

  const { totalQty, bySize } = mprReadSizeQuantities(root);

  if (!totalQty) {
    mprSetUnitPriceLabel(root, "Unit Price");
    unitEl.textContent = "$0";
    return;
  }

  const tiersFromDom = mprReadTiersFromDom(root);
  const tierOptIndex = mprFindQuantityTierIndex(productData);
  const tierOptValue = tierOptIndex >= 0 ? mprPickQtyTierValue(productData, totalQty) : null;

  const sizeIndex = findOptionIndex(productData, ["size", "sizes", "sizing"]);
  const variants = productData?.variants || [];
  const selected = variants.find((v) => v.id === productData.selected_variant_id) || variants[0];

  function unitPriceForSize(sizeValOrNull) {
    if (tierOptIndex >= 0 && tierOptValue) {
      const overrides = { [tierOptIndex]: tierOptValue };
      if (sizeIndex >= 0 && sizeValOrNull != null) overrides[sizeIndex] = sizeValOrNull;

      const v = mprVariantMatchesSelectedWithOverrides(productData, overrides) || selected;
      return mprPriceToDollars(v?.price);
    }

    if (tiersFromDom && tiersFromDom.length) {
      if (sizeIndex >= 0 && sizeValOrNull != null) {
        const v = mprVariantMatchesSelectedWithOverrides(productData, { [sizeIndex]: sizeValOrNull }) || selected;
        return mprTieredPrice(v?.price, totalQty, tiersFromDom);
      }
      return mprTieredPrice(selected?.price, totalQty, tiersFromDom);
    }

    if (sizeIndex >= 0 && sizeValOrNull != null) {
      const v = mprVariantMatchesSelectedWithOverrides(productData, { [sizeIndex]: sizeValOrNull }) || selected;
      return mprPriceToDollars(v?.price);
    }

    return mprPriceToDollars(selected?.price);
  }

  if (sizeIndex >= 0 && bySize.length) {
    const groups = new Map();
    let weightedSum = 0;

    for (let i = 0; i < bySize.length; i++) {
      const row = bySize[i];
      const price = unitPriceForSize(row.size);
      const key = (Math.round(price * 100) / 100).toFixed(2);
      const sizeLabel = String(row.size).toUpperCase();

      if (!groups.has(key)) groups.set(key, { price, sizes: [] });
      groups.get(key).sizes.push(sizeLabel);

      weightedSum += price * row.qty;
    }

    const grouped = Array.from(groups.values()).sort((a, b) => a.price - b.price);

    const summary = grouped.map((g) => `${g.sizes.join("/")} ${mprMoney(g.price)}`).join(" • ");

    mprSetUnitPriceLabel(root, `Unit Price (${summary})`);
    unitEl.textContent = mprMoney(weightedSum);
    return;
  }

  const p = unitPriceForSize(null);
  mprSetUnitPriceLabel(root, `Unit Price (${mprMoney(p)})`);
  unitEl.textContent = mprMoney(p);
}

function mprGetSelectedLocationsCount(root) {
  const pills = root.querySelectorAll(".mprPlacePill.is-active");
  return pills.length || 0;
}

function mprGetTotalColorsAcrossSelectedLocations(root) {
  const selectedLocs = $all(root, ".mprPlacePill.is-active")
    .map((p) => p.getAttribute("data-mpr-loc"))
    .filter(Boolean);

  if (!selectedLocs.length) {
    const activeKey = mprGetActiveLocKey(root) || "front";
    const st = mprGetSavedLocState(root, activeKey);
    return (st?.colorCount && st.colorCount > 0) ? st.colorCount : 1;
  }

  let total = 0;
  for (let i = 0; i < selectedLocs.length; i++) {
    const locKey = normalizePlacementKey(selectedLocs[i]); 
    const st = mprGetSavedLocState(root, locKey) || mprGetSavedLocState(root, selectedLocs[i]);

    if (st?.colorCount && st.colorCount > 0) total += st.colorCount;
    else total += 1;
  }

  return Math.max(1, total);
}



function mprComputePrintChargesBreakdown({ method, numLocs, totalColors, qty }) {
  const emb = /embriodery|embroidery/i.test(method || "");
  const printLike = /print/i.test(method || "") && !emb;

  const q = Math.max(1, qty || 1);
  const locs = Math.max(1, numLocs || 1);
  const colors = Math.max(1, totalColors || 1);

  const extraColors = Math.max(colors - locs, 0);
  const extraLocations = Math.max(locs - 1, 0);

  if (emb) {
    const perLocationPerItem = 4.95;
    const run = perLocationPerItem * locs * q;
    return {
      setups: 0,
      run,
      total: run,
      lines: [{ label: `Embroidery run (${locs} location${locs === 1 ? "" : "s"})`, amount: run }],
    };
  }

  if (!printLike) return { setups: 0, run: 0, total: 0, lines: [] };

  const baseSetup = 40;
  const setupExtraColor = 15 * extraColors;
  const setupExtraLoc = 15 * extraLocations;
  const setups = baseSetup + setupExtraColor + setupExtraLoc;

  const runExtraColor = 0.55 * extraColors * q;
  const runExtraLoc = 2.51 * extraLocations * q;
  const run = runExtraColor + runExtraLoc;

  const lines = [
    { label: "Base setup", amount: baseSetup },
    ...(extraColors ? [{ label: `$15.00 × ${extraColors} extra color setup`, amount: setupExtraColor }] : []),
    ...(extraLocations ? [{ label: `$15.00 × ${extraLocations} extra location setup`, amount: setupExtraLoc }] : []),
    ...(extraColors ? [{ label: `$0.55 × ${extraColors} extra color(s) × ${q} item(s)`, amount: runExtraColor }] : []),
    ...(extraLocations ? [{ label: `$2.51 × ${extraLocations} extra location(s) × ${q} item(s)`, amount: runExtraLoc }] : []),
  ];

  return { setups, run, total: setups + run, lines };
}

function mprGetSelectedDecorationMethod(root) {
  const btn = $(root, "[data-mpr-decos] .mpr__deco.is-selected");
  return (btn?.textContent || "").trim();
}



function mprUpdateAddToCartLabel(root, total) {
  const btn = root.querySelector("[data-mpr-addtocart]");
  if (!btn) return;
  if (!btn.dataset.mprBaseLabel) {
    btn.dataset.mprBaseLabel = (btn.textContent || "").trim() || "Add to Order";
  }
  const base = btn.dataset.mprBaseLabel;
  const n = Number(total);
  if (!Number.isFinite(n) || n <= 0) {
    btn.textContent = base;
    return;
  }
  btn.textContent = `${base} - ${mprMoney(n)}`;
}




function mprUpdateCheckoutTotalsUI(root, productData) {
  const setupsEl = $(root, "[data-mpr-setups]");
  const totalEl = $(root, "[data-mpr-total]");
  const unitEl = $(root, "[data-mpr-unitprice]");

  if (!setupsEl && !totalEl) return;

  const { totalQty, bySize } = mprReadSizeQuantities(root);

  if (!totalQty) {
    if (setupsEl) setupsEl.textContent = mprMoney(0);
    if (totalEl) totalEl.textContent = mprMoney(0);
    if (unitEl) unitEl.textContent = mprMoney(0);
    mprUpdateAddToCartLabel(root, 0);
    return;
  }

  const method = mprGetSelectedDecorationMethod(root);
  const numLocs = mprGetSelectedLocationsCount(root) || 1;
  const totalColors = mprGetTotalColorsAcrossSelectedLocations(root) || 1;

  const charges = mprComputePrintChargesBreakdown({
    method,
    numLocs,
    totalColors,
    qty: totalQty,
  });

  if (setupsEl) setupsEl.textContent = mprMoney(charges.total);
  const setupsLabel = $(root, "[data-mpr-setups-label]");
  if (setupsLabel) setupsLabel.textContent = "Setup Charge:";

  const tiersFromDom = mprReadTiersFromDom(root);
  const tierOptIndex = mprFindQuantityTierIndex(productData);
  const tierOptValue = tierOptIndex >= 0 ? mprPickQtyTierValue(productData, totalQty) : null;
  const sizeIndex = findOptionIndex(productData, ["size", "sizes", "sizing"]);

  const variants = productData?.variants || [];
  const selected = variants.find((v) => v.id === productData.selected_variant_id) || variants[0];

  function unitPriceForSize(sizeValOrNull) {
    if (tierOptIndex >= 0 && tierOptValue) {
      const overrides = { [tierOptIndex]: tierOptValue };
      if (sizeIndex >= 0 && sizeValOrNull != null) overrides[sizeIndex] = sizeValOrNull;
      const v = mprVariantMatchesSelectedWithOverrides(productData, overrides) || selected;
      return mprPriceToDollars(v?.price);
    }
    if (tiersFromDom && tiersFromDom.length) {
      if (sizeIndex >= 0 && sizeValOrNull != null) {
        const v = mprVariantMatchesSelectedWithOverrides(productData, { [sizeIndex]: sizeValOrNull }) || selected;
        return mprTieredPrice(v?.price, totalQty, tiersFromDom);
      }
      return mprTieredPrice(selected?.price, totalQty, tiersFromDom);
    }

    if (sizeIndex >= 0 && sizeValOrNull != null) {
      const v = mprVariantMatchesSelectedWithOverrides(productData, { [sizeIndex]: sizeValOrNull }) || selected;
      return mprPriceToDollars(v?.price);
    }

    return mprPriceToDollars(selected?.price);
  }

  let productTotal = 0;

  if (sizeIndex >= 0 && bySize.length) {
    for (let i = 0; i < bySize.length; i++) {
      const row = bySize[i];
      productTotal += unitPriceForSize(row.size) * row.qty;
    }
  } else {
    productTotal = unitPriceForSize(null) * totalQty;
  }

  const grandTotal = productTotal + charges.total;
  if (totalEl) totalEl.textContent = mprMoney(grandTotal);
  mprUpdateAddToCartLabel(root, grandTotal);
}

(function bindMprThumbs() {
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-mpr-thumb]");
    if (!btn) return;

    const mpr = btn.closest(".mpr");
    if (!mpr) return;

    const main = mpr.querySelector("[data-mpr-mainimg]");
    if (!main) return;

    const full = btn.getAttribute("data-full");
    if (!full) return;

    if (main.tagName === "IMG") {
      main.src = full;
      main.removeAttribute("srcset");
    }
    mpr.querySelectorAll("[data-mpr-thumb][aria-current='true']").forEach((b) => {
      b.removeAttribute("aria-current");
    });
    btn.setAttribute("aria-current", "true");
  });

  document.addEventListener("pointerup", (e) => {
    const btn = e.target.closest("[data-mpr-thumb]");
    if (btn) btn.click();
  });
})();

(function bindZoomPopoverToStage() {
  function qs(root, sel){ return (root || document).querySelector(sel); }

  function findOverlayRootFrom(el){
    return el?.closest?.("[data-mpr-overlay]") || document;
  }

  function closePop(overlayRoot){
    const pop = qs(overlayRoot, "[data-mpr-zoom-pop]");
    const toggle = qs(overlayRoot, "[data-mpr-zoom-toggle]");
    if (pop) pop.hidden = true;
    if (toggle) toggle.setAttribute("aria-expanded", "false");
  }

  document.addEventListener("click", (e) => {
    const toggleBtn = e.target.closest?.("[data-mpr-zoom-toggle]");
    if (toggleBtn) {
      const overlayRoot = findOverlayRootFrom(toggleBtn);
      const pop = qs(overlayRoot, "[data-mpr-zoom-pop]");
      if (!pop) return;

      const next = pop.hidden;    
      pop.hidden = !next;
      toggleBtn.setAttribute("aria-expanded", next ? "true" : "false");
      return;
    }

    const openPop = document.querySelector("[data-mpr-zoom-pop]:not([hidden])");
    if (openPop && !e.target.closest("[data-mpr-zoom-pop]") && !e.target.closest("[data-mpr-zoom-toggle]")) {
      const overlayRoot = findOverlayRootFrom(openPop);
      closePop(overlayRoot);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const openPop = document.querySelector("[data-mpr-zoom-pop]:not([hidden])");
    if (!openPop) return;
    const overlayRoot = findOverlayRootFrom(openPop);
    closePop(overlayRoot);
  });
})();



function mprGetStageRect(oroot){
  const stage =
    oroot.querySelector(".mprOverlayStage__inner") ||
    oroot.querySelector(".mprOverlay__imgStage") ||
    oroot.querySelector("[data-mpr-stage]");
  const box = oroot.querySelector("[data-mpr-logo-box]");
  if (!stage || !box) return null;
  return { stage, box };
}




function mprSaveLogoRectNorm(oroot, locKeyOverride){
  const got = mprGetStageRect(oroot);
  if (!got) return;
  const { stage, box } = got;

  const w = stage.clientWidth || 1;
  const h = stage.clientHeight || 1;

  const norm = {
    x: box.offsetLeft / w,
    y: box.offsetTop / h,
    w: box.offsetWidth / w,
    h: box.offsetHeight / h,
  };

  const locKey =
    String(locKeyOverride || "").trim() ||
    mprGetActiveLocKey(oroot) ||
    (mprGetOverlay(oroot)?.dataset?.mprActiveLocKey || "front");

  mprSaveLocState(oroot, locKey, { rectNorm: norm });
}





function mprRestoreLogoRectNorm(oroot, locKeyOverride){
  const got = mprGetStageRect(oroot);
  if (!got) return;
  const { stage, box } = got;

  const locKey =
    String(locKeyOverride || "").trim() ||
    mprGetActiveLocKey(oroot) ||
    (mprGetOverlay(oroot)?.dataset?.mprActiveLocKey || "front");

  const st = mprGetSavedLocState(oroot, locKey);
  const norm = st?.rectNorm || null;
  if (!norm) return;

  const clamp = (n,a,b) => Math.max(a, Math.min(b, n));
  const W = stage.clientWidth || 1;
  const H = stage.clientHeight || 1;
  const minW = 70, minH = 40;

  const wPx = Math.max(minW, norm.w * W);
  const hPx = Math.max(minH, norm.h * H);

  const xPx = clamp(norm.x * W, 0, W - wPx);
  const yPx = clamp(norm.y * H, 0, H - hPx);

  box.style.left = xPx + "px";
  box.style.top = yPx + "px";
  box.style.width = wPx + "px";
  box.style.height = hPx + "px";
}



function mprGetActiveColorLabel(root){

  const el = root.querySelector("[data-mpr-colorlabel]");
  return (el?.textContent || "").trim() || "—";
}

function mprGetLogoThumbSrc(root){
  const img = root.querySelector("[data-mpr-logo-img]");
  return img?.getAttribute("src") || "";
}

function mprGetMoneyText(root, sel){
  const el = root.querySelector(sel);
  return (el?.textContent || "").trim() || "$0";
}

function mprRenderFinalOrder(root, productData){
  const overlay = root.closest("[data-mpr-overlay]") || root;
  const qtySec = overlay.querySelector('[data-mpr-sec="qty"]');
  if (!qtySec) return;

  const titleEl = qtySec.querySelector(".mprOverlay__secTitleA");
  if (titleEl) titleEl.textContent = "";

  const finalEl = qtySec.querySelector("[data-mpr-finalorder]");
  if (!finalEl) return;

  const qtyTotal = mprResolveTotalQtyFromOverlay(root, productData);

  const unitPriceLabel =
    (root.querySelector("[data-mpr-unitprice-label]")?.textContent || "Unit Price:").trim();
  const unitPriceValue =
    (root.querySelector("[data-mpr-unitprice]")?.textContent || "$0").trim();

  const totalText = mprGetMoneyText(root, "[data-mpr-total]");
  const locationLabel = "Front";

  const name = productData?.title || "Product";
  const color = mprGetActiveColorLabel(root);

  const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;
  const mockupSrc = (overlay.dataset.mprMockupUrl || "").trim();

  const stageImg =
    overlay.querySelector("[data-mpr-overlay-img]") ||
    root.querySelector("[data-mpr-overlay-img]");

  const baseSrc = mockupSrc || (stageImg?.getAttribute("src") || "");



  const logoUrl =
  (root.querySelector('input[type="hidden"][data-mpr-logo-url]')?.value || "").trim();


  let rect = null;
  try { rect = JSON.parse((overlay.querySelector("[data-mpr-overlay-root]") || overlay).dataset.mprLogoRect || "null"); }
  catch { rect = null; }

  finalEl.hidden = false;

  finalEl.innerHTML = `
    <div class="mprFinalOrder__card">

      <div class="mprFinalOrder__mock">
        <img class="mprFinalOrder__base" src="${baseSrc}" alt="">
      </div>



      <div class="mprFinalOrder__metaStack">
        <div class="mprFinalOrder__name"></div>
        <div class="mprFinalOrder__sub"></div>
      </div>

      <div class="mprFinalOrder__lines">


        <div class="mprFinalOrder__line mprFinalOrder__line--unit">
          <span></span>
          <strong>${unitPriceValue}</strong>
        </div>



        <div class="mprFinalOrder__line mprFinalOrder__line--total">
          <span>
            Total
            <button type="button" class="mprFinalOrder__breakLink" data-mpr-break-toggle>
              (see full price breakdown)
            </button>
          </span>
          <strong>${totalText}</strong>
        </div>


      </div>

    </div>
  `;

  const nameEl = finalEl.querySelector(".mprFinalOrder__name");
  if (nameEl) nameEl.textContent = name;

  const subEl = finalEl.querySelector(".mprFinalOrder__sub");
  if (subEl) subEl.innerHTML = `${color} • Qty: <strong>${qtyTotal}</strong> • Location: <strong>${locationLabel}</strong>`;

  const unitSpan = finalEl.querySelector(".mprFinalOrder__line--unit span");
  if (unitSpan) unitSpan.textContent = unitPriceLabel.replace(/:\s*$/, "");

  const logoEl = finalEl.querySelector(".mprFinalOrder__logoOnMock");
  if (logoEl && rect) {
    logoEl.style.left = (rect.x * 100) + "%";
    logoEl.style.top = (rect.y * 100) + "%";
    logoEl.style.width = (rect.w * 100) + "%";
    logoEl.style.height = (rect.h * 100) + "%";
  }
}







(function () {
  const overlay = document.querySelector('[data-mpr-overlay]');
  if (!overlay) return;

  const nextBtn = overlay.querySelector('[data-mpr-next]');
  const backBtn = overlay.querySelector('[data-mpr-panel-back]');
  const panelTitle = overlay.querySelector('.mprOverlayPanel__headTitle');
  const continueBtn = overlay.querySelector('[data-mpr-continue]');
  const qtySec = overlay.querySelector('[data-mpr-sec="qty"]');


  function getProductDataFromOverlayRoot(){
    const overlayEl = document.querySelector("[data-mpr-overlay]");
    const id = overlayEl?.dataset?.mprActiveId;
    if (!id) return null;

    const dataTag = document.getElementById(`mpr-product-${id}`);
    if (!dataTag) return null;

    try { return JSON.parse(dataTag.textContent || "{}"); }
    catch { return null; }
  }


  


  function enterQtyStep() {
    const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;

    const prices = overlay.querySelector("[data-mpr-prices]");
    const finalEl = overlay.querySelector("[data-mpr-finalorder]");
    const addBtn = overlay.querySelector("[data-mpr-add]");

    if (prices) prices.hidden = true;
    if (finalEl) finalEl.hidden = true;
    if (addBtn) addBtn.hidden = true;


    mprSaveLogoRectNorm(overlayRoot);

    overlay.classList.add('is-step-qty');
    if (panelTitle) panelTitle.textContent = 'Quantity';
    if (continueBtn) continueBtn.hidden = false;

    requestAnimationFrame(() => mprRestoreLogoRectNorm(overlayRoot));

    qtySec?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }



  function exitQtyStep() {
    const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;
    mprSaveLogoRectNorm(overlayRoot);

    overlay.classList.remove('is-step-qty');
    if (panelTitle) panelTitle.textContent = 'Product & Decoration Options';
    if (continueBtn) continueBtn.hidden = true;

    requestAnimationFrame(() => mprRestoreLogoRectNorm(overlayRoot));
  }





  function enterReviewStep() {
    const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;

    const prices = overlay.querySelector("[data-mpr-prices]");
    const finalEl = overlay.querySelector("[data-mpr-finalorder]");
    const addBtn = overlay.querySelector("[data-mpr-add]");

    if (prices) prices.hidden = true;   
    if (finalEl) finalEl.hidden = false; 
    if (addBtn) addBtn.hidden = false;
    if (continueBtn) continueBtn.hidden = true;


    const shell = mprGetShell(overlayRoot) || overlay;

    mprSaveLogoRectNorm(overlayRoot);

    const productData = getProductDataFromOverlayRoot();
    if (!productData) return;

    mprUpdateCheckoutTotalsUI(shell, productData);

    overlay.classList.add("is-review");
    if (panelTitle) panelTitle.textContent = "Final Order";

    mprRenderFinalOrder(shell, productData);

    requestAnimationFrame(() => mprRestoreLogoRectNorm(overlayRoot));
    qtySec?.scrollIntoView({ block: "start", behavior: "smooth" });
  }





  function exitReviewStep() {
    const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;
    const finalEl =
      overlayRoot.querySelector("[data-mpr-finalorder]") ||
      overlay.querySelector("[data-mpr-finalorder]");
    if (finalEl) {
      finalEl.hidden = true;
      finalEl.innerHTML = "";
    }

    mprSaveLogoRectNorm(overlayRoot);

    overlay.classList.remove("is-review");
    if (panelTitle) panelTitle.textContent = "Quantity";
    const qtySec = overlay.querySelector('[data-mpr-sec="qty"]') || overlay;

    const btnContinue =
      qtySec.querySelector("[data-mpr-continue]");    

    const btnAdd =
      qtySec.querySelector("[data-mpr-add]");

    if (btnContinue) {
      btnContinue.hidden = false;
      btnContinue.disabled = false;
      if (btnContinue.tagName === "BUTTON") btnContinue.type = "button";
      if (btnContinue.dataset?.mprLabelContinue) {
        btnContinue.textContent = btnContinue.dataset.mprLabelContinue;
      } else if ((btnContinue.textContent || "").trim().toLowerCase() !== "continue") {
        btnContinue.textContent = "Continue";
      }
    }

    if (btnAdd) {
      btnAdd.hidden = true;
      btnAdd.disabled = false; 
    }

    requestAnimationFrame(() => mprRestoreLogoRectNorm(overlayRoot));
  }







  nextBtn?.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;

    const old = nextBtn.textContent;
    nextBtn.disabled = true;
    nextBtn.textContent = "Preparing…";

    try {
      mprSaveLogoRectNorm(overlayRoot);

      //await mprSendLogoToWorkerOnNext(overlayRoot);


      await mprShowClientPreview(overlayRoot);
      mprKickoffWorkerMockup(overlayRoot);


      enterQtyStep();
    } catch (err) {
      console.error("[mpr-next-worker] failed:", err);
      nextBtn.textContent = old || "Next";

      if (String(err?.message || "") === "no-logo") {
        alert("Please upload your logo first.");
      } else {
        alert("Could not process logo. Please try again.");
      }
    } finally {
      nextBtn.disabled = false;
      nextBtn.textContent = old || "Next";
    }
  });




  backBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (overlay.classList.contains("is-review")) {
      exitReviewStep();
      return;
    }

    if (overlay.classList.contains('is-step-qty')) {
      exitQtyStep();
    }
  });


  continueBtn?.addEventListener("click", async (e) => {
  if (!overlay.classList.contains("is-step-qty")) return;

  e.preventDefault();
  e.stopPropagation();

  const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;

  const old = continueBtn.textContent;
  continueBtn.disabled = true;
  continueBtn.textContent = "Finalizing…";

  overlay.classList.add("is-busy");

  try {
    const p = mprEnsureWorkerPromise(overlayRoot);
    const result = p ? await p : null;

    //mprApplyWorkerMockupIfPresent(overlayRoot, result);

    enterReviewStep();
  } catch (err) {
    console.error("[mpr-continue-worker] failed:", err);

    enterReviewStep();
  } finally {
    overlay.classList.remove("is-busy");
    continueBtn.disabled = false;
    continueBtn.textContent = old || "Continue";
  }
  });



  if (!overlay.dataset.mprBreakBound) {
    overlay.dataset.mprBreakBound = "1";

    overlay.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-mpr-break-toggle]");
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();

      const dlg = overlay.querySelector("[data-mpr-break-modal]");
      const body = overlay.querySelector("[data-mpr-break-body]");
      if (!dlg || !body) return;

      const productData = getProductDataFromOverlayRoot();
      const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;
      const shell = mprGetShell(overlayRoot) || overlay;
      if (!productData) return;

      body.innerHTML = mprRenderPriceBreakdownHTML(shell, productData);

      if (typeof dlg.showModal === "function") dlg.showModal();
      else dlg.setAttribute("open", ""); 
    });

    overlay.addEventListener("click", (e) => {
      const closeBtn = e.target.closest("[data-mpr-break-close]");
      if (!closeBtn) return;

      e.preventDefault();
      const dlg = closeBtn.closest("dialog");
      if (!dlg) return;

      if (typeof dlg.close === "function") dlg.close();
      else dlg.removeAttribute("open");
    });

    const dlg = overlay.querySelector("[data-mpr-break-modal]");
    if (dlg) {
      dlg.addEventListener("click", (e) => {
        if (e.target === dlg) dlg.close?.();
      });
    }
  }



  overlay.querySelectorAll('[data-mpr-overlay-close]').forEach((btn) => {
    btn.addEventListener('click', () => exitQtyStep());
  });
})();



(function bindMprWorkerUploadV2() {
  const UPLOAD_ENDPOINT = "https://logo-upload.inkdstores.workers.dev/upload";
  

  if (window.__mprWorkerUploadV2Bound) return;
  window.__mprWorkerUploadV2Bound = true;

  const CLICK_COOLDOWN_MS = 500;

  function getOverlayRootFrom(el) {
    return (
      el?.closest?.("[data-mpr-overlay-root]") ||
      el?.closest?.("[data-mpr-overlay]") ||
      el?.closest?.(".mprOverlay") ||
      document
    );
  }

  function isStageUploadButton(btn) {
    if (!btn) return false;
    return !!btn.closest?.("[data-mpr-printbox], .mprPrintArea, [data-mpr-stage], .mprOverlayStage__inner, .mprOverlay__imgStage");
  }

  function pickBestFileInput(overlayRoot) {
    const panel = overlayRoot.querySelector('input[type="file"].mprUploadPanel__fileInput');
    if (panel) return panel;

    const loc = overlayRoot.querySelector('input[type="file"][data-mpr-loc-file]');
    if (loc) return loc;

    const stage = overlayRoot.querySelector('input[type="file"][data-mpr-stage-file]');
    if (stage) return stage;

    return null;
  }

  function getProductName(overlayRoot) {
    const overlay = overlayRoot?.closest?.("[data-mpr-overlay]") || overlayRoot;
    return (
      overlay?.getAttribute?.("data-product-name") ||
      overlay?.dataset?.productName ||
      overlayRoot?.getAttribute?.("data-product-name") ||
      overlayRoot?.dataset?.productName ||
      ""
    );
  }

  function isLocked(overlayRoot) {
    return overlayRoot?.dataset?.mprUploadLock === "1";
  }
  function lock(overlayRoot) {
    if (!overlayRoot) return;
    overlayRoot.dataset.mprUploadLock = "1";
  }
  function unlockSoon(overlayRoot, ms = CLICK_COOLDOWN_MS) {
    if (!overlayRoot) return;
    window.setTimeout(() => {
      if (overlayRoot.dataset.mprUploadLock === "1") overlayRoot.dataset.mprUploadLock = "0";
    }, ms);
  }
  function lockForUpload(overlayRoot, on) {
    if (!overlayRoot) return;
    overlayRoot.dataset.mprUploadBusy = on ? "1" : "0";
    overlayRoot.dataset.mprUploadLock = on ? "1" : "0";
  }
  function isBusy(overlayRoot) {
    return overlayRoot?.dataset?.mprUploadBusy === "1";
  }

  async function uploadToWorker(file, productName) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("product_name", productName || "");

    const res = await fetch(UPLOAD_ENDPOINT, { method: "POST", body: fd });
    if (!res.ok) throw new Error("Upload failed: " + res.status);

    const data = await res.json();
    if (!data || !data.url) throw new Error("Upload failed: no URL in response");
    return data;
  }

  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest?.("[data-mpr-stage-upload]");
      if (!btn) return;

      if (!isStageUploadButton(btn)) return;

      const overlayRoot = getOverlayRootFrom(btn);
      if (!overlayRoot || overlayRoot === document) return;

      if (isBusy(overlayRoot) || isLocked(overlayRoot)) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      const input = pickBestFileInput(overlayRoot);
      if (!input) return;

      lock(overlayRoot);
      e.preventDefault();
      e.stopPropagation();

      input.click();
      unlockSoon(overlayRoot, CLICK_COOLDOWN_MS);
    },
    true
  );

  document.addEventListener(
    "change",
    async (e) => {
      const input = e.target;
      if (!(input instanceof HTMLInputElement) || input.type !== "file") return;

      const isPanel = input.classList.contains("mprUploadPanel__fileInput");
      const isLoc = input.hasAttribute("data-mpr-loc-file");
      const isStage = input.hasAttribute("data-mpr-stage-file");
      if (!isPanel && !isLoc && !isStage) return;

      const overlayRoot = getOverlayRootFrom(input);
      if (!overlayRoot || overlayRoot === document) return;

      const file = input.files?.[0];
      if (!file) return;

      lockForUpload(overlayRoot, true);

      const stageBtn =
        overlayRoot.querySelector("[data-mpr-printbox] [data-mpr-stage-upload]") ||
        overlayRoot.querySelector(".mprPrintArea [data-mpr-stage-upload]") ||
        overlayRoot.querySelector("[data-mpr-stage] [data-mpr-stage-upload]");

      const urlHidden = overlayRoot.querySelector('input[type="hidden"][data-mpr-logo-url]');
      const nameEl = overlayRoot.querySelector("[data-mpr-upload-filename], [data-mpr-logo-filename]");

      if (nameEl) nameEl.textContent = file.name;


      try {
        const result = await uploadToWorker(file, getProductName(overlayRoot));

        if (urlHidden) urlHidden.value = result.url || "";
        const group = input.closest(".mprUploadGroup") || input.closest(".mprUploadPanel") || null;
        if (group) group.classList.add("has-logo");

        console.log("[mpr-upload] uploaded ->", result.url);
      } catch (err) {
        console.error("[mpr-upload] Failed:", err);
        if (stageBtn) stageBtn.textContent = "Upload (error, try again)";
        if (urlHidden) urlHidden.value = "";
      } finally {
        lockForUpload(overlayRoot, false);
        input.value = ""; 
      }
    },
    true
  );
})();









(function bindMprAddToCart() {
  async function addLinesToCart(lines) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: lines }),
    });

    if (!res.ok) {
      const txt = await res.text().catch(() => "");
      throw new Error("Cart add failed: " + res.status + " " + txt);
    }
    return res.json();
  }

  function getProductDataFromOverlay(overlay) {
    const id = overlay?.dataset?.mprActiveId;
    if (!id) return null;
    const tag = document.getElementById(`mpr-product-${id}`);
    if (!tag) return null;
    try { return JSON.parse(tag.textContent || "{}"); } catch { return null; }
  }

  function getSelectedLocationsPayload(root) {
    const locs = mprReadSelectedLocationsWithColors(root); 
    const names = (locs || []).map(x => x.name).filter(Boolean);
    const colors = (locs || []).map(x => `${x.name}:${x.colors}`).filter(Boolean);

    return {
      names,
      colors,
      totalLocs: names.length || (mprGetSelectedLocationsCount(root) || 0),
      totalColors: mprGetTotalColorsAcrossSelectedLocations(root) || 1,
    };
  }

  function computeDecorationChargeDollars(root, qty) {
    const method = mprGetSelectedDecorationMethod(root);
    const numLocs = mprGetSelectedLocationsCount(root) || 1;
    const totalColors = mprGetTotalColorsAcrossSelectedLocations(root) || 1;
    const charges = mprComputePrintChargesBreakdown({ method, numLocs, totalColors, qty });
    return { method, charges };
  }


  function mprBuildDecorationBreakdownText(root, charges) {
    const fm = (d) => mprFormatMoney(root, d);

    const lines = (charges?.lines || []).map((l) => `${l.label} ${fm(l.amount)}`);

    lines.push(`Total Decoration ${fm(charges?.total || 0)}`);

    return lines.join("\n");
  }



  function buildLineProperties(root, productData, qty) {
    const overlay = mprGetOverlay(root);
    const shell = mprGetShell(root);

    const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;

    const logoUrl =
      (overlayRoot.querySelector('input[type="hidden"][data-mpr-logo-url]')?.value || "").trim();

    //const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;


  //  const logoUrl =
  //(shell.querySelector('input[type="hidden"][data-mpr-logo-url]')?.value || "").trim();


    const mockupUrl =
  (overlay?.dataset?.mprMockupUrl || "").trim() ||
  (shell.querySelector('input[type="hidden"][data-mpr-mockup-url]')?.value || "").trim();


    const method = mprGetSelectedDecorationMethod(root) || "";
    const locPayload = getSelectedLocationsPayload(root);
    const locNames = (locPayload?.names || []).filter(Boolean);

    const locationText = locNames.length ? locNames.join(", ") : "Front";

    const rectJson = (overlayRoot.dataset.mprLogoRect || "").trim();

    return {
      "Logo URL": logoUrl,   
      "Mockup URL": mockupUrl,  
      "Decoration": method,
      "Decoration Location": locationText
    };
  }



  function buildLinesFromSizeMatrix(root, productData) {
    const { totalQty, bySize } = mprReadSizeQuantities(root);
    const qty = Math.max(1, totalQty || 1);

    const sizeIndex = findOptionIndex(productData, ["size", "sizes", "sizing"]);
    const tierOptIndex = mprFindQuantityTierIndex(productData);
    const tierOptValue = tierOptIndex >= 0 ? mprPickQtyTierValue(productData, qty) : null;

    const variants = productData?.variants || [];
    const selected = variants.find(v => v.id === productData.selected_variant_id) || variants[0];
    if (!selected) return null;

    if (!(sizeIndex >= 0 && bySize && bySize.length)) {
      return [{
        id: selected.id,
        quantity: qty,
        properties: buildLineProperties(root, productData, qty),
      }];
    }


    const lines = [];
    for (const row of bySize) {
      const q = Math.max(0, mprParseQty(row.qty));
      if (!q) continue;

      const overrides = {};
      if (tierOptIndex >= 0 && tierOptValue) overrides[tierOptIndex] = tierOptValue;
      overrides[sizeIndex] = row.size;

      const v = mprVariantMatchesSelectedWithOverrides(productData, overrides) || selected;

      lines.push({
        id: v.id,
        quantity: q,
        properties: buildLineProperties(root, productData, qty), 
      });
    }

    return lines.length ? lines : null;
  }

document.addEventListener(
  "click",
  async (e) => {
    const btn = e.target.closest("[data-mpr-add]");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    const form = btn.closest("form");
    if (form) {
      form.addEventListener(
        "submit",
        (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          if (typeof ev.stopImmediatePropagation === "function") ev.stopImmediatePropagation();
        },
        { capture: true, once: true }
      );
    }

    const overlay = btn.closest("[data-mpr-overlay]");
    const root = overlay?.querySelector("[data-mpr-overlay-root]") || overlay;
    if (!overlay || !root) return;

    const productData = getProductDataFromOverlay(overlay);
    if (!productData) return;

    const gate = mprUpdateQtyGate(root, productData);
    if (!gate.ok) return;

    //const logoUrl = (root.querySelector("[data-mpr-logo-url]")?.value || "").trim();


    const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;
    const logoUrl = (overlayRoot.querySelector('input[type="hidden"][data-mpr-logo-url]')?.value || "").trim();


    const lines = buildLinesFromSizeMatrix(root, productData);
    if (!lines || !lines.length) return;

    // Decoration Charge
    const decoVariantId = (() => {
      const n = parseInt(String(window.__DECORATION_CHARGE_VARIANT_ID__ || ""), 10);
      return Number.isFinite(n) && n > 0 ? n : null;
    })();

    if (decoVariantId) {
      const qtyTotal = mprResolveTotalQtyFromOverlay(root, productData);

      const { charges } = computeDecorationChargeDollars(root, qtyTotal);
      const decoDollars = Math.max(0, charges?.total || 0);

      const decoCents = Math.round((decoDollars + Number.EPSILON) * 100);
      const decoQty = Math.max(0, decoCents);



      if (decoQty > 0) {
        const overlay = mprGetOverlay(root);
        const overlayRoot = overlay.querySelector("[data-mpr-overlay-root]") || overlay;

        // const logoUrl = (overlayRoot.querySelector("[data-mpr-logo-url]")?.value || "").trim();
        const logoUrl = (overlayRoot.querySelector('input[type="hidden"][data-mpr-logo-url]')?.value || "").trim();

        const mockupUrl = (overlay?.dataset?.mprMockupUrl || "").trim();

        const method = mprGetSelectedDecorationMethod(root) || "";
        const locPayload = getSelectedLocationsPayload(root);
        const locNames = (locPayload?.names || []).filter(Boolean);
        const locationText = locNames.length ? locNames.join(", ") : "Front";

        lines.push({
          id: decoVariantId,
          quantity: decoQty,
          properties: {
            "Linked Product": productData?.title || "",
            "Decoration Charge": mprFormatMoney(root, decoDollars),
            "Logo URL": logoUrl,
            "Mockup URL": mockupUrl,
            "Decoration": method,
            "Decoration Location": locationText,
          },
        });
      }

    }

    const old = btn.textContent;
    btn.disabled = true;
    btn.textContent = "Adding…";
    console.log("ADDING LINES:", lines.map(l => ({ id: l.id, quantity: l.quantity })));

    try {
      await addLinesToCart(lines);
      window.location.href = "/cart";


      btn.textContent = "Added ✓";
    } catch (err) {
      console.error("[mpr-add] failed", err);
      btn.textContent = "Add to cart (error)";
      alert("Could not add to cart. Please try again.");
    } finally {
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = old;
      }, 900);
    }
  },
  true 
);

})();






















/*
(function () {
  const qs = new URLSearchParams(location.search);
  if (qs.get("calibrate") !== "1") return;

  function run() {


  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const round4 = (n) => Math.round(n * 10000) / 10000;

  function pickTargetImage() {
    const pdpImg = document.querySelector("[data-mpr-mainimg]");
    if (pdpImg && pdpImg.tagName === "IMG") return pdpImg;

    const ovImg = document.querySelector("[data-mpr-overlay-img]");
    if (ovImg && ovImg.tagName === "IMG") return ovImg;

    return null;
  }

    const input = document.querySelector("[data-mpr-site-input]");
    let _mprSiteLast = "";
    const site = input?.value || "";
    const norm = (window.mprNormalizeSiteInput ? mprNormalizeSiteInput(site) : site.trim());

    if (norm && norm !== _mprSiteLast) _mprSiteLast = norm;



    function pickTargetImage() {
      const pdpImg = document.querySelector("[data-mpr-mainimg]");
      if (pdpImg && pdpImg.tagName === "IMG") return pdpImg;

      const ovImg = document.querySelector("[data-mpr-overlay-img]");
      if (ovImg && ovImg.tagName === "IMG") return ovImg;

      return null;
    }

    let targetImg = null;
    let layer = null;
    let box = null;
    let ui = null;
    let start = null;
    let mode = null;
    let handle = null;

    function ensureLayer(img) {
      if (layer && layer.parentNode) layer.parentNode.removeChild(layer);

      targetImg = img;

      const parent =
        img.closest(".mpr__imgStage, .mprOverlayStage__inner, .mpr__media") || img.parentElement;
      if (!parent) return;

      if (getComputedStyle(parent).position === "static") parent.style.position = "relative";

      layer = document.createElement("div");
      layer.className = "mprCalLayer";
      layer.style.cssText = `position:absolute; inset:0; pointer-events:auto; z-index:999999;`


      parent.appendChild(layer);

      ui = document.createElement("div");
      ui.style.cssText = `
        position:absolute; left:12px; top:12px; z-index:100;
        display:flex; gap:10px; align-items:center;
        background: rgba(0,0,0,.65); color:#fff;
        padding:10px 12px; border-radius:12px;
        font: 12px/1.2 system-ui, -apple-system, Segoe UI, Roboto, Arial;
        pointer-events:auto;
      `;

      const viewInput = document.createElement("input");
      viewInput.type = "text";
      viewInput.placeholder = "view key (front/back/sleeve)";
      viewInput.value = "front";
      viewInput.style.cssText = `
        width:180px; height:30px; border-radius:8px; border:0;
        padding:0 10px; outline:none;
      `;

      const saveBtn = document.createElement("button");
      saveBtn.type = "button";
      saveBtn.textContent = "Save JSON → console";
      saveBtn.style.cssText = `
        height:30px; border-radius:8px; border:0; cursor:pointer;
        padding:0 10px; font-weight:800;
      `;

      const tip = document.createElement("span");
      tip.textContent = "Drag/resize box on image. Shift = keep aspect.";
      tip.style.cssText = "opacity:.85; white-space:nowrap;";

      ui.append(viewInput, saveBtn, tip);
      layer.appendChild(ui);

      box = document.createElement("div");
      box.className = "mprCalBox";
      box.style.cssText = `
        position:absolute; z-index:98;
        border:2px dashed rgba(255,255,255,.95);
        background: rgba(255,255,255,.10);
        border-radius:10px;
        box-sizing:border-box;
        cursor: move;
        pointer-events:auto;
      `;
      layer.appendChild(box);

      const handles = ["nw", "ne", "sw", "se"].map((pos) => {
        const h = document.createElement("div");
        h.dataset.handle = pos;
        h.style.cssText = `
          position:absolute; width:14px; height:14px; border-radius:999px;
          background:#fff; box-shadow: 0 4px 12px rgba(0,0,0,.25);
          ${pos.includes("n") ? "top:-7px" : "bottom:-7px"};
          ${pos.includes("w") ? "left:-7px" : "right:-7px"};
          cursor:${pos}-resize;
        `;
        box.appendChild(h);
        return h;
      });

      setBoxNorm({ x: 0.3, y: 0.25, w: 0.4, h: 0.4 });

      function getImgRect() {
        return targetImg.getBoundingClientRect();
      }

      function setBoxNorm(r) {
        box.dataset.x = String(r.x);
        box.dataset.y = String(r.y);
        box.dataset.w = String(r.w);
        box.dataset.h = String(r.h);
        layout();
      }

      function getBoxNorm() {
        return {
          x: round4(clamp(parseFloat(box.dataset.x || "0"), 0, 1)),
          y: round4(clamp(parseFloat(box.dataset.y || "0"), 0, 1)),
          w: round4(clamp(parseFloat(box.dataset.w || "0"), 0, 1)),
          h: round4(clamp(parseFloat(box.dataset.h || "0"), 0, 1)),
        };
      }

      function layout() {
        if (!targetImg) return;

        const imgRect = getImgRect();
        const parentRect = parent.getBoundingClientRect();

        const x0 = imgRect.left - parentRect.left;
        const y0 = imgRect.top - parentRect.top;

        const r = getBoxNorm();
        const left = x0 + r.x * imgRect.width;
        const top = y0 + r.y * imgRect.height;
        const wpx = r.w * imgRect.width;
        const hpx = r.h * imgRect.height;

        box.style.left = left + "px";
        box.style.top = top + "px";
        box.style.width = wpx + "px";
        box.style.height = hpx + "px";
      }

      const ro = new ResizeObserver(() => layout());
      ro.observe(parent);
      ro.observe(targetImg);

      window.addEventListener("resize", layout);

      function onDown(e) {
        const t = e.target;
        const isHandle = t && t.dataset && t.dataset.handle;
        mode = isHandle ? "resize" : "move";
        handle = isHandle ? t.dataset.handle : null;

        const imgRect = getImgRect();
        const r = getBoxNorm();

        start = {
          clientX: e.clientX,
          clientY: e.clientY,
          imgW: imgRect.width,
          imgH: imgRect.height,
          leftPx: r.x * imgRect.width,
          topPx: r.y * imgRect.height,
          wPx: r.w * imgRect.width,
          hPx: r.h * imgRect.height,
        };

        e.preventDefault();
        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseup", onUp, { once: true });
      }

      function onMove(e) {
        if (!start) return;
        const dx = e.clientX - start.clientX;
        const dy = e.clientY - start.clientY;

        let left = start.leftPx;
        let top = start.topPx;
        let w = start.wPx;
        let h = start.hPx;

        const minSize = 20;
        const keepAspect = e.shiftKey;
        const aspect = start.wPx / start.hPx;

        if (mode === "move") {
          left = clamp(start.leftPx + dx, 0, start.imgW - w);
          top = clamp(start.topPx + dy, 0, start.imgH - h);
        } else {
          if (handle.includes("e")) w = clamp(start.wPx + dx, minSize, start.imgW - start.leftPx);
          if (handle.includes("s")) h = clamp(start.hPx + dy, minSize, start.imgH - start.topPx);

          if (handle.includes("w")) {
            const newLeft = clamp(start.leftPx + dx, 0, start.leftPx + start.wPx - minSize);
            w = start.leftPx + start.wPx - newLeft;
            left = newLeft;
          }
          if (handle.includes("n")) {
            const newTop = clamp(start.topPx + dy, 0, start.topPx + start.hPx - minSize);
            h = start.topPx + start.hPx - newTop;
            top = newTop;
          }

          if (keepAspect) {
            const wFromH = h * aspect;
            const hFromW = w / aspect;
            if (Math.abs(wFromH - w) < Math.abs(hFromW - h)) w = wFromH;
            else h = hFromW;

            w = clamp(w, minSize, start.imgW);
            h = clamp(h, minSize, start.imgH);
            left = clamp(left, 0, start.imgW - w);
            top = clamp(top, 0, start.imgH - h);
          }
        }

        const nx = left / start.imgW;
        const ny = top / start.imgH;
        const nw = w / start.imgW;
        const nh = h / start.imgH;

        box.dataset.x = String(nx);
        box.dataset.y = String(ny);
        box.dataset.w = String(nw);
        box.dataset.h = String(nh);

        layout();
      }

      function onUp() {
        start = null;
        window.removeEventListener("mousemove", onMove);
        mode = null;
        handle = null;
      }

      box.addEventListener("mousedown", onDown);
      handles.forEach((h) => h.addEventListener("mousedown", onDown));

      saveBtn.addEventListener("click", () => {
        const viewKey = (viewInput.value || "front").trim();
        const src = targetImg.currentSrc || targetImg.src || "";
        const rect = getBoxNorm();
        const out = { [viewKey]: { src, ...rect } };

        console.log("[custom.print_areas snippet]", JSON.stringify(out, null, 2));
        console.log("[single-line]", JSON.stringify(out));
      });

      if (targetImg.complete) layout();
      else targetImg.addEventListener("load", layout, { once: true });

      console.log("[calibrate] enabled on PDP image. Drag/resize on image and Save to console.");
    }

    const img0 = pickTargetImage();
    if (!img0) {
      console.warn(
        "[calibrate] No target image found. Expected [data-mpr-mainimg] or [data-mpr-overlay-img]."
      );
      return;
    }
    ensureLayer(img0);

    const mainImg = document.querySelector("[data-mpr-mainimg]");
    if (mainImg) {
      const mo = new MutationObserver(() => {
        if (targetImg === mainImg) {
          window.dispatchEvent(new Event("resize"));
        }
      });
      mo.observe(mainImg, { attributes: true, attributeFilter: ["src", "srcset"] });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }
})();

*/



























